/* eslint-disable react/no-unescaped-entities */

import React from "react";
import moment from "moment";
import "./terms.scss";

export const PassportAgreementSila = ({
  info = {
    effectiveDate: moment().format("MMMM D, YYYY"),
  },
}) => {
  return (
    <>
      <div className="terms-of-service" id={"passport-agreement"}>
        <div>
          <p>Effective Date: {info.effectiveDate}</p>
          <p>
            This Passport Account Agreement (together with the applicable Rate
            Sheet, this “Agreement”) governs the use of the accounts (each, a
            “Passport Account” or “Account”) made available to you by a
            federally insured depository institution (“Bank
            <sup>[1]</sup>
            ”) and Priority Technology Holdings, Inc. (together with its
            subsidiaries, “Priority”), as a technology service provider of
            banking related services. Money transmission services are provided
            by Priority, directly or through its subsidiary Finxera, Inc. (NMLS
            #1168701) or its authorized affiliates and contractors. As used in
            this Agreement, the words “we”, “our”, and “us” refer to Bank and
            Priority and our respective successors, affiliates, or assignees;
            and the words “you”, and “your” refer to the entity that owns the
            Passport Account (the “Account Owner”) and anyone else with the
            authority to deposit, withdraw, or exercise control over the funds
            in the Passport Account.
          </p>
          <p>
            “Passport Account” refers to any account, now or in the future,
            opened through Passport, a proprietary technology platform owned by
            Priority which enables Priority’s customers to set up one or more
            accounts to collect, store, and send money; in addition to other
            functionalities. When you open an Account, you will be provided a
            document for the type of Account you are opening (the “Rate Sheet”)
            that sets forth the additional requirements and restrictions for the
            Account, the fees applicable to the Account, and the interest rate,
            if applicable. Each Rate Sheet is part of this Agreement. Access to
            your Passport Account and the services under this Agreement is
            available only through the website and, when available, a smart
            phone application (the “Mobile App”) (collectively, the “Passport
            Website”), unless we notify you otherwise. Passport Accounts opened
            for business purposes (“Commercial Accounts”) may only be used for
            such business purposes. Passport Account opened by individuals
            (“Consumer Accounts”) may be used for personal, family or household
            purposes. This Agreement, along with any other documents we make
            available to you and referenced in this Agreement pertaining to your
            Passport Account, is a contract that establishes the rules that
            govern your Passport Account. For Commercial Accounts, if you sign a
            written or electronic signature card or open a Passport Account, you
            are deemed to agree to the most recent version of this Agreement,
            which can be accessed{" "}
            <a href="https://prioritycommerce.com/enterprise-payments/passport/legal-terms/">
              here
            </a>{" "}
            or by calling us at the number set forth in Section 6.10. For
            Consumer Accounts, by electronically signing this Agreement, you
            acknowledge receipt of this Agreement and agree to the terms set
            forth in the Agreement. This Agreement may be changed by us from
            time to time, as described in Section 6.9 below. This Agreement also
            includes Priority’s privacy policies, as referred to in Section 2.7
            below, any other agreement you enter into with us, and any other
            terms and conditions made available to you by us on the Passport
            Website.
          </p>
          <p>
            <strong>
              YOU UNDERSTAND THAT BY OPENING A PASSPORT ACCOUNT, YOU AUTHORIZE
              BANK TO ACCEPT ALL INSTRUCTIONS PROVIDED TO BANK BY PRIORITY ON
              YOUR BEHALF.
            </strong>
          </p>
          <p>
            <strong>THIS AGREEMENT CONTAINS AN ARBITRATION </strong>
            <strong>
              AGREEMENT. YOU SHOULD READ THE ARBITRATION AGREEMENTCAREFULLY. IF
              YOU OWN A CONSUMER ACCOUNT, YOU MAY REJECT THE ARBITRATION
              AGREEMENT. IF YOU OWN A CONSUMER ACCOUNT AND DO NOT REJECT THE
              ARBITRATION AGREEMENT, IT WILL HAVE A SUBSTANTIAL IMPACT ON THE
              WAY LEGAL DISPUTES BETWEEN YOU AND US ARE RESOLVED. FOR EXAMPLE,
              IF YOU OWN A CONSUMER ACCOUNT AND DO NOT REJECT THE ARBITRATION
              CLAUSE, WE CAN REQUIRE INDIVIDUAL ARBITRATION OF LEGAL DISPUTES
              WITH YOU REGARDING THE ACCOUNT AND YOU WILL NOT HAVE THE RIGHT TO
              BRING OR PARTICIPATE IN ANY CLASS ACTION OR SIMILAR PROCEEDING IN
              COURT OR IN ARBITRATION.
            </strong>
          </p>
          <ol>
            <li>
              <strong>CONSENT</strong> <strong>TO</strong> <strong>USE</strong>{" "}
              <strong>ELECTRONIC</strong> <strong>SIGNATURES,</strong>{" "}
              <strong>COMMUNICATIONS</strong> <strong>AND</strong>{" "}
              <strong>STATEMENTS.</strong>
              <ol>
                <li>
                  <strong>
                    Your Consent to Electronic Communications and Electronic
                    Signatures
                  </strong>
                  . To the fullest extent permitted by law, this Agreement, any
                  application, privacy policies, account statements, notices,
                  legal and rate disclosures for your Passport Account,
                  including, but not limited to, those made pursuant to the
                  Electronic Fund Transfer Act/Regulation E or the Truth in
                  Savings Act/Regulation DD, updates and changes to this
                  Agreement, end-of-year tax forms, other service agreements,
                  and other communications (collectively, “Communications”) from
                  us to you regarding your Passport Account and related services
                  provided by us may be provided to you electronically. By
                  submitting an application or opening an Account, you agree to
                  the terms set forth in this Section 1 (the “E-Sign
                  Disclosure”) and consent to (i) receive all such
                  Communications in electronic form; and (ii) use electronic
                  signatures. If you choose not to consent to this E-Sign
                  Disclosure or if you withdraw your consent, you may be unable
                  to use the Accounts and the related services.
                </li>
                <li>
                  <strong>Methods of Providing Communications</strong>. Unless
                  otherwise required by applicable law, or Priority otherwise
                  agrees, Priority may provide Communications to you by (a)
                  posting them on the Passport Website; (b) notifying you
                  through your statements; (c) sending a text message to the
                  mobile phone number listed in your Account profile; (d)
                  sending an email to the email address in our record; or (e)
                  delivering them in another electronic format. Charges by your
                  telecommunication provider may apply to Communications sent by
                  text or other electronic means.
                </li>
                <li>
                  <strong>Electronic Signatures</strong>. Priority may execute
                  Communications electronically. If Priority requests, you will
                  execute Communications electronically. You also agree that
                  Communications you or Priority sign electronically will have
                  the same legal effect as a signed physical document.
                </li>
                <li>
                  <strong>Hardware and Software Requirements</strong>. In order
                  to access, view, sign and retain electronic Communications
                  that Priority provides to you, you must have:
                  <ol>
                    <li>
                      An up-to-date device (e.g., computer, tablet, or mobile
                      phone) which has internet access;
                    </li>
                    <li>
                      A current, compatible web browser, including the current
                      or immediately preceding version of Chrome, Internet
                      Explorer, Firefox, Safari and Edge;
                    </li>
                    <li>A valid email account;</li>
                    <li>
                      An operating system on your device capable of receiving,
                      accessing and displaying Communications in electronic form
                      via text-formatted email or gaining access to the Passport
                      Website using a supported browser, including any necessary
                      software (e.g., Adobe to read PDF documents); and
                    </li>
                    <li>
                      If you wish to store or print any Communications, a device
                      capable of storing and printing Communications.
                    </li>
                    <li>
                      If you use a spam filter that blocks or re-routes emails
                      from senders not listed in your email address book, you
                      must add relevant Priority email accounts to your email
                      address book.
                    </li>
                  </ol>
                </li>
                <li>
                  <strong>Accessibility</strong>. If you are having problems
                  viewing or accessing any Communications, please contact
                  Priority as provided in Section 6.10.
                </li>
                <li>
                  <strong>How to Withdraw Your Consent</strong>. If you want to
                  withdraw your consent to receive electronic Communications or
                  electronic signature, you may do so by writing to Priority at
                  the address provided in Section 6.10. Your withdrawal of
                  consent to receive electronic Communications will be effective
                  after Priority has had a reasonable period of time to process
                  your withdrawal. By withdrawing your consent to electronic
                  Communications, you will no longer receive them from Priority,
                  but you may be disabling important security controls on your
                  Passport Account, you may increase the risk of loss to your
                  business, and your ability to use the services relating to the
                  Passport Account may be adversely affected or terminated. If
                  you withdraw your consent, you may be unable to use the
                  Accounts and the related services.{" "}
                </li>
                <li>
                  <strong>Requesting Paper Copies</strong>. You can request
                  paper copies of electronic Communications from Priority by
                  contacting customer service as provided in Section 6.10. In
                  your request, please specify the Communication you would like
                  to receive in paper form, and your current mailing address.
                </li>
                <li>
                  <strong>Updating Contact Information</strong>. It is your
                  responsibility to keep your contact information, including
                  your primary email address, current. You can update your
                  primary email address and other contact information by logging
                  into your Passport Account.
                </li>
                <li>
                  <strong>U.S. Federal Law</strong>. You acknowledge and agree
                  that the Passport Account and all services related to it are
                  subject to the federal Electronic Signatures in Global and
                  National Commerce Act (“E-SIGN Act”), and that you intend that
                  the E-SIGN Act will apply to validate your ability to engage
                  electronically in transactions related to the Passport Account
                  and the related services.
                </li>
                <li>
                  <strong>Statements. </strong>Statements will be made available
                  to you to view and/or print on the Passport Website. We will
                  send an email notification when the statements are available
                  online on a periodic basis at approximately monthly intervals.
                  The Passport Account statement, in either paper or electronic
                  form, will describe each item, date of credit or debit, and
                  the respective amount for the period since the last statement
                  period. As to Commercial Accounts, Passport Account statements
                  will be considered correct, and neither Bank nor Priority will
                  have any liability to you, unless you notify us, by calling us
                  or sending us an email as provided in Section 6.10, noting
                  “Billing Error” on the subject line, of any errors within
                  sixty (60) days of such statement becoming available.{" "}
                </li>
              </ol>
            </li>
            <li>
              <strong>ACCOUNT</strong> <strong>BASICS. </strong>
              <ol>
                <li>
                  <strong>Eligibility</strong>. The Commercial Accounts are
                  available to legal entities with an Employer Identification
                  Number and individuals who are at least 18 years old (or older
                  if residing in a state where the majority age is older), have
                  a Social Security Number or Individual Taxpayer Identification
                  Number and have a street address in (i) the U.S., (ii) the
                  territories of Puerto Rico, United States Virgin Islands or
                  American Samoa (“U.S. Territories”);”or (iii) a U.S. military
                  base or U.S. embassy (i.e., an Army/Air Post Office, Fleet
                  Post Office, or Diplomatic Post Office address) (“U.S.
                  Jurisdictions”). You cannot use a post office box (other than
                  on a U.S. military base or at a Diplomatic Post Office) to
                  open or maintain an Account. The Consumer Accounts are
                  available to individuals who are at least 18 years old (or
                  older if residing in a state where the majority age is older),
                  have a Social Security Number or Individual Taxpayer
                  Identification Number and have a street address in (i) the
                  U.S., (ii) the U.S. Territories; or (iii) the U.S.
                  Jurisdictions. All deposits and withdrawals must be in U.S.
                  dollars only.{" "}
                  <strong>
                    You must agree to accept electronic, rather than paper,
                    statements as provided in Section 1 above. If you do not do
                    so, you may not open a Passport Account.
                  </strong>{" "}
                  You agree to provide certain information to us pursuant to
                  Section 2.3 and authorize us or Bank to verify your identify,
                  credit history, history of receiving income for an
                  individual), and/or have a credit reporting agency prepare a
                  credit report on you or, for Commercial Accounts, any of your
                  beneficial owners. You may open a Passport Account only if you
                  satisfy our review of your credit history and other
                  information relating to you, based on our internal risk
                  management policies. We may refuse to comply with a power of
                  attorney for reasonable cause to the extent permitted by law.{" "}
                </li>
                <li>
                  <strong>Joint Accounts</strong>. For Consumer Accounts, the
                  Account can be a “Joint Account,” which is owned by two or
                  more people (up to four people per account, and each is
                  regarded as an Account Owner). Each Account Owner has access
                  to the Joint Account and may take any action or initiate any
                  transaction (including withdrawing funds) or close the
                  Account. All Joint Accounts are owned by the Account Owners as
                  joint tenants with right of survivorship, meaning that if one
                  of the Account Owners dies, the funds in the Account belong to
                  the surviving Account Owner(s). If two or more Account Owners
                  survive, the Account will remain a joint tenancy with right of
                  survivorship. The Account Owner that opens the Joint Account
                  will serve as the “Primary Owner” and receive tax documents,
                  including 1099s. The Primary Owner can only be changed by
                  closing the Account and opening a new Joint Account with
                  another Primary Owner designated.
                </li>
                <li>
                  <strong>Authorized Signers</strong>. Commercial Accounts may
                  have “Authorized Signers,” who are persons with authority to
                  act on your behalf. Unless a restriction that we have
                  acknowledged in writing is specifically stated in your
                  authorizing resolution, (i) an Authorized Signer will have
                  authority to appoint the authorized users on your Passport
                  Account (each, an “Authorized User”), to add or delete
                  Authorized Users on your Passport Account, to open additional
                  accounts, to close the Passport Account, and to give us any
                  other instructions on your behalf with respect to your
                  Passport Accounts; and (ii) each Authorized Signer may do
                  these things acting alone, unless we require otherwise. We
                  may, but are not obligated to, accept oral instructions from
                  your Authorized Users. Account Owners of Consumer Accounts may
                  also appoint Authorized Users of their Account. As between you
                  and us, all actions of an Authorized Signer or an Authorized
                  User shall be deemed within the scope of such person’s
                  authority. We are not required to verify or confirm the
                  purpose or propriety of any action by your Authorized Signers
                  or Authorized Users and are not responsible for any
                  misapplication or misappropriation of funds by your Authorized
                  Signers or Authorized Users. Authorized Signers and the
                  Authorized Users shall have the authority: (i) to make
                  withdrawals and, if offered as a Passport Account feature, to
                  draw checks, drafts or other orders for the payment of money
                  on your account(s); and (ii) to issue or cancel stop payment
                  orders on your Passport Account. Each authorization that we
                  receive from you or your Authorized Signers shall remain in
                  effect until we receive written notice of revocation and have
                  a reasonable opportunity to act on such notice. For Commercial
                  Accounts, you acknowledge that we will treat any person
                  identified as an officer of the company, either in your
                  authorization resolutions or in such person’s signature, as an
                  Authorized Signer of you.
                </li>
                <li>
                  <strong>
                    Important information about procedures for opening a new
                    Passport Account
                  </strong>
                  . To help the government fight the funding of terrorism and
                  money laundering activities, Federal law requires all
                  financial institutions to obtain, verify, and record
                  information that identifies each person who opens an account.
                  In the case that a Commercial Account is opened by a legal
                  entity, we will obtain, verify, and record information on all
                  ultimate beneficial owners and a controlling person of such
                  legal entity. What this means for you: When you open a
                  Passport Account, we will ask for the names, addresses, dates
                  of birth, and other information concerning, for Commercial
                  Accounts, each controlling person of the Account Owner and its
                  direct or indirect beneficial owners owning 25% or more of the
                  equity interests of the Account Owner; and for Consumer
                  Accounts, each individual Account Owner. We may also ask to
                  see a copy of the driver’s license or other identifying
                  documents of each controlling person and beneficial
                  owner’s/Account Owner.{" "}
                </li>
                <li>
                  <strong>Passport Account</strong>. The Passport Account is an
                  online account used to hold your deposits and make payments
                  and transfers to and from such Passport Account. You will
                  access your Passport Account via the Passport Website. If made
                  available, depending on the type of Account you own, the
                  Passport Account may include the use of a debit card to make
                  payments and transfers to third parties. Use of a debit card
                  linked to a Commercial Account will be subject to the terms
                  and conditions contained in the Commercial Cardholder
                  Agreement, and use of a debit card linked to a Consumer
                  Account will be subject to the terms and conditions contained
                  in the Consumer Prepaid Cardholder Agreement, each of which
                  can be accessed{" "}
                  <a href="https://prioritycommerce.com/enterprise-payments/passport/legal-terms/">
                    here
                  </a>{" "}
                  (each, a “Cardholder Agreement”). You must agree to the
                  applicable Cardholder Agreement before a debit card will be
                  issued to you. If you instruct us to issue debit cards to any
                  third parties, including your employees, you are responsible
                  for their compliance with the applicable Cardholder Agreement.
                </li>
                <li>
                  <strong>Password Security. </strong>You are responsible for
                  maintaining adequate security and control of any and all User
                  IDs, Passwords, hints, personal identification numbers (PINs),
                  or any other codes that you use to access the Passport Account
                  (collectively, “Security Devices”). Do not discuss, compare,
                  or share information about your Security Devices unless you
                  are willing to give them full use of your money. Any loss or
                  compromise of any Security Device and/or your personal
                  information may result in unauthorized access to your Passport
                  Account by third parties and the loss or theft of any funds
                  held in your Passport Account and any associated accounts.
                  Checks and electronic withdrawals are processed by automated
                  methods, and anyone who obtains your Security Devices could
                  use them to withdraw money from your account, with or without
                  your permission. You are responsible for keeping your email
                  address and telephone number up to date in order to receive
                  any notices or alerts that we may send you. For Commercial
                  Accounts, we assume no responsibility for any loss that you
                  may sustain due to compromise of your Security Devices due to
                  no fault of ours and/or your failure to follow or act on any
                  notices or alerts that we may send to you. For Consumer
                  Accounts, liability for unauthorized use in such cases is
                  governed by Section 5. If you believe your Passport Account
                  information has been compromised, or that someone has
                  transferred or may transfer money from your Account without
                  your permission, contact us immediately as provided in Section
                  6.10. You agree to promptly review all Passport Account and
                  transaction records and other Communications that we make
                  available to you and to promptly report any discrepancy to us.
                </li>
                <li>
                  <strong>Location</strong>. Priority’s headquarters is located
                  in the State of Georgia.{" "}
                </li>
                <li>
                  <strong>Privacy Policies</strong>. Priority’s general privacy
                  policy is available at{" "}
                  <a href="https://prioritycommerce.com/privacy/">
                    https://prioritycommerce.com/privacy/
                  </a>{" "}
                  and its consumer privacy notice is available at{" "}
                  <a href="https://prioritycommerce.com/enterprise-payments/passport/legal-terms/">
                    https://prioritycommerce.com/enterprise-payments/passport/legal-terms/
                  </a>
                  . These documents are considered part of this Agreement. By
                  executing this Agreement, you acknowledge that you have read
                  and accepted Priority’s privacy policy, and for Account Owners
                  of Consumer Accounts, the consumer privacy notice.
                </li>
                <li>
                  <strong>Internet Gambling; Illegal Transactions</strong>. We
                  may, but are not required to, deny authorization for any
                  internet gambling transactions or any other activity or
                  business that is unlawful under the Unlawful Internet Gambling
                  Enforcement Act of 2006, 31 U.S.C. §&nbsp;5361 <em>et seq</em>{" "}
                  (the “UIGEA”). You agree not to use your Passport Account or
                  our services for online gambling or any illegal activity under
                  the UIGEA. We may refuse to process any transaction that we
                  believe may violate the terms of this Agreement or applicable
                  law, including the UIGEA. You acknowledge and agree that we
                  have no obligation to monitor, review or evaluate the legality
                  of your transactions and Passport Account activities. You
                  agree that using your Passport Account for illegal activity
                  will be deemed a default and/or breach of contract and, in
                  such event, our services and/or any of your Passport Accounts
                  may be terminated at our discretion. You further agree that
                  should illegal use occur, unless prohibited by applicable law,
                  you waive any right to sue us in court for such illegal use or
                  any activity directly or indirectly related to it, and you
                  agree to indemnify and hold us harmless from any suits, legal
                  action, or liability directly resulting from such illegal use.
                  To the fullest extent permitted by law, you agree to pay for
                  any transaction that you authorized, even if that transaction
                  is determined to be illegal.
                </li>
                <li>
                  <strong>
                    Freezes, Blocking or Closing Passport Accounts Due to
                    Irregular or Unlawful Activities
                  </strong>
                  . You agree that if we suspect that any irregular,
                  unauthorized, or unlawful activity may be occurring in
                  connection with your Passport Account, we may “freeze” or
                  place a hold on the balance in the Passport Account pending an
                  investigation of such activity. If we freeze your Passport
                  Account, we will give any notice required under the
                  circumstances by the laws governing the Passport Account. If
                  investigation confirms our suspicions of irregular,
                  unauthorized, or unlawful activity then, notwithstanding
                  anything to the contrary in this Agreement, we may immediately
                  close your Passport Account, if necessary, to comply with
                  applicable law. You agree that we may also freeze, block, or
                  close your Passport Account as necessary in order to comply
                  with regulations issued by the United States Department of
                  Treasury’s Office of Foreign Assets Control (“OFAC”).
                </li>
                <li>
                  <strong>
                    Disclosing Information about You and Your Account.
                  </strong>{" "}
                  For Consumer Accounts, we may disclose information about your
                  Account to credit bureaus and other persons or agencies who,
                  in our judgment, have a legitimate purpose for obtaining such
                  information. For example, subject to any applicable financial
                  privacy laws or regulations, we may provide information on you
                  and your Account or the transactions you make:{" "}
                  <ol className="parenthesis">
                    <li>
                      To anyone who we reasonably believe is conducting a
                      legitimate credit inquiry, including inquiries to verify
                      the existence or condition of an account for a third party
                      such as a lender, merchant or consumer reporting agency;
                    </li>
                    <li>
                      In response to any subpoena, summons, court or
                      administrative order or other legal process that we
                      believe requires our compliance and to extent permitted by
                      law;{" "}
                    </li>
                    <li>
                      In connection with collection of indebtedness or to report
                      losses incurred by us;{" "}
                    </li>
                    <li>Where it is necessary for completing transfers;</li>
                    <li>To enforce our rights under this Agreement; or</li>
                    <li>If you give us your written permission.</li>
                  </ol>
                </li>
              </ol>
              <p>
                <strong>
                  We may report information about your Account to credit
                  bureaus. Late payments, missed payments or other defaults
                  (including overdrafts) on your Account may be reflected in
                  your credit report.
                </strong>
              </p>
              <p>
                The terms of our privacy policies, as referenced in Section 2.7,
                govern in the event of a conflict between the terms of this
                section and the terms of our privacy policies, including the
                consumer privacy notice.
              </p>
            </li>
            <li>
              <strong>FUNDING AND WITHDRAWING FROM YOUR ACCOUNT</strong>
              <ol>
                <li>
                  <strong>Transactions.</strong> We will disburse available
                  funds from your Passport Account to third parties based on
                  instructions received from you. You, any Authorized Signers,
                  and the Authorized Users are the only ones who have the right
                  to authorize transactions involving your Passport Account. You
                  authorize us to initiate and facilitate disbursements from
                  your Passport Account to pay debit entries and payments made
                  by us on your behalf (“Transfer Service”). Moreover, you
                  authorize us to deduct from your Passport Account any Transfer
                  Service fees pursuant to the Fee Schedule; and to the extent
                  applicable, any refunds, Chargebacks, Processing Fees (each as
                  defined in your Services Application and Agreement with
                  Priority (collectively, the “Merchant Agreement”), if
                  applicable), and other amounts payable by you to us pursuant
                  to any agreement you have with us for any services involving
                  the Passport Account, as they become due. We will not provide
                  Transfer Service when we know there are insufficient funds in
                  your Passport Account. You will be responsible for ensuring
                  that your Passport Account does not have a negative balance.
                  We will not provide back-up funding under this Agreement, nor
                  do we guarantee that all requested transfers or payments can
                  or will be made when there are insufficient funds in the
                  Passport Account. Instructions received after our established
                  transaction cut-off hour or on non-business days will be
                  processed on the next business day.
                </li>
                <li>
                  <strong>Deposits to the Passport Account</strong>. In addition
                  to depositing merchant processing settlement proceeds in the
                  Passport Account, as applicable, subject to the limitations
                  set forth in the Rate Sheet, you can make deposits into your
                  Passport Account using any of these methods. We may establish
                  limits on the amount you can deposit into your Passport
                  Account per day if we reasonably believe that such limits are
                  necessary.
                  <div className="table-wrapper">
                    <table
                      style={{
                        border: "1px solid black",
                        borderCollapse: "collapse",
                      }}
                    >
                      <tbody>
                        <tr style={{ backgroundColor: "#f0f0f0" }}>
                          <td style={{ border: "1px solid black" }}>
                            <u>Transaction Type</u>
                          </td>
                        </tr>
                        <tr>
                          <td style={{ border: "1px solid black" }}>
                            Direct deposits or ACH Transfers initiated from an
                            outside financial institution
                          </td>
                        </tr>
                        <tr>
                          <td style={{ border: "1px solid black" }}>
                            Wires initiated from an outside financial
                            institution
                          </td>
                        </tr>
                        <tr>
                          <td style={{ border: "1px solid black" }}>
                            ACH Transfers (debit) initiated by us on your behalf
                            from linked bank accounts
                          </td>
                        </tr>
                        <tr>
                          <td style={{ border: "1px solid black" }}>
                            Remote Deposit Capture (RDC)
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <ol>
                    <li>
                      Preauthorized credits. For Consumer Accounts, if you have
                      arranged to have direct deposits made to your Account at
                      least once every 60 days from the same person or company,
                      you can verify the deposits on your Account portal or call
                      us at the phone number in Section 6.10 to find out whether
                      or not the deposit has been made.
                    </li>
                    <li>
                      Linking Bank Accounts. You may link one or more external
                      accounts at third-party financial institutions (each
                      linked external account, an “External Account”) for online
                      transfers between your External Accounts and your Passport
                      Account. You may link your external accounts with your
                      Passport Account by (i) logging into your financial
                      institution on the Passport, or (ii) providing the account
                      and routing details for the external account and verifying
                      the two (2) micro deposits we send to your external
                      account the next business day. We may also verify your
                      control of the External Account by requiring you to submit
                      proof of ownership of the External Accounts. All External
                      Accounts must be with financial institutions in the United
                      States. We may decline the use of any external account
                      that we believe may present a risk to you and/or us. When
                      adding an External Account, you represent and warrant that
                      you are the owner of and have the right to access and use
                      the account and to authorize us to use the account for
                      information and funds transfer purposes. If any of your
                      External Accounts has a joint account holder, you
                      represent and warrant that the joint account holder has
                      consented for you to represent both you and them, and to
                      use the External Account with the Passport Account. If you
                      do not have such consent, you should not use that external
                      account and we will terminate your use of the linking
                      service if we are notified of such a situation. If you
                      close any of your External Accounts, you are responsible
                      for removing it as an account eligible for the linking
                      service to avoid any transaction failure and possible
                      charges related to a failed transaction. We are not
                      responsible for any acts or omissions by the external
                      financial institution or other provider of any External
                      Account, including, without limitation, any modification,
                      interruption, or discontinuance of any External account by
                      such financial institution or service provider.
                    </li>
                    <li>
                      Remote Deposit Capture (“RDC”). If enabled for your
                      Passport Account, you may make deposits into your Passport
                      Account by using the Mobile App to take a legible picture
                      of the front and back of a negotiable check and
                      transmitting such images. RDC services are subject to the
                      Remote Deposit Capture Services Agreement (the “RDC
                      Agreement”), a copy of which may be accessed{" "}
                      <a href="https://prioritycommerce.com/enterprise-payments/passport/legal-terms/">
                        here
                      </a>
                      . By using the RDC service, you agree that you will be
                      bound by the terms of the RDC Agreement and will follow
                      any and all other procedures and instructions for use of
                      RDC that we may establish from time to time.{" "}
                    </li>
                    <li>
                      No Deposits in Cash, Paper Checks or Foreign Currency. The
                      Passport Account will only accept funds deposited
                      electronically. We are not liable for any deposits,
                      including cash, lost in the mail, lost in transit, or not
                      received by us. We do not accept deposits in cash or any
                      paper personal checks, cashier’s checks, money orders or
                      foreign currency. If we receive any of these instruments
                      by mail, we will return it to the address we have for you
                      on file. Only deposits made in accordance with the terms
                      of this Agreement will be accepted.
                    </li>
                    <li>
                      Our Right to Charge Back Deposited Checks or Electronic
                      Transfers. If you deposit a check or receive an electronic
                      transfer as provided in this Agreement, and (i) the paying
                      bank returns it to us unpaid; (ii) the paying bank or the
                      issuer of a check demands that we repay them because the
                      check was altered, forged or unauthorized, is missing a
                      signature or endorsement, or has a forged endorsement; or
                      (iii) the sending bank or the originator of an item
                      demands that we return the item because it was
                      unauthorized, sent to the wrong account number or procured
                      by fraud, we may pay the return or demand, and subtract
                      the funds from your Passport Account, unless prohibited by
                      law or applicable network rules. If we have reason to
                      believe that any of the events in the previous sentence
                      have occurred or may occur, or that the check or other
                      item should not have been paid or may not be paid for any
                      be paid for any other reason, we may place a hold on the
                      funds or move them to a non-customer account until we
                      determine who is entitled to them, unless prohibited by
                      law or applicable network rules.{" "}
                    </li>
                    <li>
                      Right to Reject Any Deposit. We may refuse any check for
                      deposit, with or without cause, or may elect to take a
                      check on a collection basis only. We are under no
                      obligation to accept any item, wire, electronic funds
                      transfer, or other transaction for deposit to your
                      Passport Account or for collection, and we may refuse to
                      cash or give value for any such item. We may restrict
                      access to any deposit credited to your account that
                      violates any laws of the United States, including those
                      giving rise to OFAC sanctions. Unless specifically
                      permitted to do so, you may not deposit any Substitute
                      Check that has not been previously handled by a bank in
                      the collection process. This means you cannot deposit a
                      Substitute Check you create, or one that is created by
                      another person, unless we enter into an agreement to do
                      so. Nevertheless, if a Substitute Check is received for
                      deposit, you will be responsible for any losses you or
                      another person suffers relating to that Substitute Check.
                    </li>
                  </ol>
                </li>
                <li>
                  <strong>Withdrawals from the Passport Account</strong>. You
                  can make withdrawals or disbursements from your Passport
                  Account using any of these methods, subject to the limitations
                  set forth in the Rate Sheet. Federal regulations give us the
                  right to require you to give at least seven (7) days’ notice
                  in writing prior to any intended withdrawal from the Account.
                  Although we usually pay withdrawals or checks without notice,
                  doing so does not mean that we give up this right. Depending
                  on the Account type of your Account, the number of withdrawals
                  you may make per month may be limited. See your Rate Sheet for
                  additional information.{" "}
                  <div className="table-wrapper">
                    <table border={1}>
                      <tbody>
                        <tr>
                          <td>
                            <strong>Transaction Type</strong>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            ACH Transfers (credit) to an external financial
                            institution initiated by us or linked bank accounts
                          </td>
                        </tr>
                        <tr>
                          <td>Wires (if enabled for your Passport Account)</td>
                        </tr>
                        <tr>
                          <td>
                            Bill Pay services (if enabled for your Passport
                            Account)
                          </td>
                        </tr>
                        <tr>
                          <td>
                            Debit Card Payments (if enabled for your Passport
                            Account)
                          </td>
                        </tr>
                        <tr>
                          <td>
                            Virtual Card Payments (if enabled for your Passport
                            Account)
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <p>
                    In addition to the limitation with regard to the
                    disbursement of Faster Funds (defined in Section 4.2) set
                    forth in Section 4.2 and the limitations set forth in the
                    Rate Sheet for certain Account types, we may establish
                    limits on the amount you can withdraw from your Account per
                    day in the future if we reasonably believe that such limits
                    are necessary.{" "}
                  </p>
                  <ol>
                    <li>
                      Preauthorized payments.
                      <ol className="parenthesis">
                        <li>
                          Right to stop payment and procedure for doing
                          so.&nbsp;If you have told us in advance to make
                          regular payments out of your Account, you can stop any
                          of these payments. Here’s how:
                          <p style={{ marginLeft: "20px", marginTop: "10px" }}>
                            Contact us using the information provided in Section
                            6.10 in time for us to receive your request at least
                            three (3) business days before the payment is
                            scheduled to be made. If you call, we may also
                            require you to put your request in writing and get
                            it to us within 14 days after you call. We may
                            charge you a fee, if any, as set forth in the Fee
                            Schedule for each stop-payment order you give.
                          </p>
                        </li>
                        <li>
                          Liability for failure to stop payment of preauthorized
                          transfer.&nbsp;If you order us to stop one of these
                          payments three (3) business days or more before the
                          transfer is scheduled, and we do not do so, we will be
                          liable for your losses or damages.
                        </li>
                      </ol>
                    </li>
                    <li>
                      Bill Pay. If enabled for your Passport Account, you will
                      be able to authorize us to make bill payments via check,
                      ACH, or wire on your behalf to third parties. You may not
                      have access to this feature until your Passport Account
                      has been open for a minimum of thirty (30) days, and this
                      feature may not be available for all Account types. Please
                      check your Rate Sheet for details. To initiate a bill
                      payment using Bill Pay, you must provide the name and
                      mailing address of each individual or company you wish to
                      pay and other information as we may reasonably require.
                      You must provide such information about each payee as we
                      may request from time to time, and in any event sufficient
                      to properly direct a payment to that payee and permit the
                      payee to identify the correct account to credit with your
                      payment. You may not make a payment of alimony,
                      child-support, taxes, or other governmental fees or
                      court-directed payments via Bill Pay. We do not recommend
                      using online bill payment services to fund brokerage or
                      investment services. We may impose a dollar amount limit
                      on bill payment transactions and will notify you in the
                      event such a limit is put in place. Loan payments made via
                      Bill Pay, other than the amounts due, cannot be designated
                      as principal, interest or payoff. Once a payment is
                      authorized, the payment amount will be immediately
                      deducted from your Passport Account balance. Payments made
                      using Bill Pay via check take the form of a paper check
                      and are sent to the payee using standard U.S. Postal
                      Service mail, or if sent to a Payee outside of the United
                      States, using a carrier service selected by us. Please
                      allow three to nine (3-9) business days for delivery of
                      the check in the U.S. and ten to twenty (10-20) days for
                      delivery of the check internally. Payments made using Bill
                      Pay via ACH or wire will be made within our standard
                      processing time for ACH or wire transactions,
                      respectively. Bill Pay payments are processed daily by
                      12:00 p.m. Eastern Time. Payments initiated after this
                      time will be processed the next business day. We reserve
                      the right to refuse to process payments to any individual
                      or company. If the decision is made to refuse a payment,
                      we will notify you on or before the next business day.
                      <ol>
                        <li>
                          Returned or Refused Checks. Checks may be refused or
                          returned by the individual or company to whom the
                          payment was issued. The determination to accept this
                          method of payment is at the discretion of the
                          recipient. The U.S. Postal Service (or the other
                          carrier selected by us) may also return payments in
                          cases of expired or invalid addresses. If the check
                          payment is returned for any reason, the payment will
                          be voided and the full amount credited to your
                          Passport Account the next business day.
                        </li>
                        <li>
                          Uncashed Checks. If we remit your payment to a payee
                          by mailing your payee a check drawn on your Passport
                          Account and the check has not been presented for
                          payment within our payment cut-off period, we will
                          attempt to contact the Payee to investigate the status
                          of the check if the Payee is an entity located in the
                          United States. If the Payee cannot be reached, or the
                          Payee is located outside of the United States, or the
                          payment is to an individual; and the check has not
                          been presented for payment by ninety (90) days after
                          the date the funds are withdrawn from your Passport
                          Account, we will place a stop payment order on the
                          check and refund your Passport Account the amount of
                          the check. If the check is later presented for
                          payment, we reserve the right to pay the check without
                          providing notice to you.
                        </li>
                        <li>
                          Cancelling a Payment. You may cancel a single check
                          payment as long as it has not been presented for
                          payment by logging into Passport Website or by
                          contacting Priority as provided in Section 6.10. Funds
                          from any cancelled check will be credited to your
                          Passport Account on the next business day. Same-day
                          payments (<em>i.e.</em>, payments entered and
                          initiated on the same date) cannot be modified or
                          deleted. You may cancel a payment by ACH as provided
                          in Section 5.7. You cannot cancel a payment made by
                          wire once the payment is processed.
                        </li>
                      </ol>
                    </li>
                    <li>
                      Checks Issued by a Third Party. We do not support the
                      issuance of personal checks to access funds in the
                      Passport Account. We reserve the right to refuse to make
                      payments initiated via a check printed by a third-party
                      service provider and not via the Bill Pay services
                      provided herein.
                    </li>
                    <li>
                      No Overdrafts. You are not permitted to overdraw your
                      Passport Account. If the available balance in Passport
                      Account you use to make a payment or withdrawal is not
                      sufficient to cover any payment or withdrawal you have
                      authorized, we may refuse to process the payment or
                      withdrawal. We may also, but are not required to, transfer
                      funds from any other Passport Accounts you have with us to
                      the appropriate Account to cover the payment or withdrawal
                      you have authorized. The “available balance” at any time
                      equals the ledger balance minus any amount that is not
                      available for withdrawal under our Funds Availability
                      Policy or under other agreements we have with you. For
                      example, if your ledger balance is $100, and you deposit a
                      check image for $100 on day 1, your ledger balance on day
                      1 is now $200, but your available balance is still $100
                      until the funds become available under our Funds
                      Availability Policy. If you do not have sufficient
                      available funds for us to honor all transactions, the
                      order of processing may affect which items we honor (if
                      any) and which items we dishonor (if any). We process
                      deposits and most credits before we post debits and other
                      withdrawals that have been received for payment against
                      your Account. Any fees we may charge are posted after all
                      other transactions have been posted. We may change the
                      processing order from time to time but will not use any
                      order designed to increase the number of overdrafts. Even
                      if we choose to approve a transaction that results in a
                      negative Account balance, we are not obligated to cover
                      any such transactions in the future. Also, even if we
                      choose to use funds in other Passport Accounts you have
                      with us to cover a transaction that would otherwise result
                      in a negative Account balance, we are not obligated to do
                      so in the future. If your Passport Account balance becomes
                      negative for any reason, you must make a deposit
                      immediately to cover the negative balance or direct us to
                      transfer funds from another Passport Account you have with
                      us. If your Passport Account has a negative balance and
                      you have other funds held by us, we reserve the right to
                      exercise our right to set off. See Section 3.7 below for
                      details. If your Passport Account has a negative balance
                      for sixty (60) calendar days or more, it will be closed.
                      If you fail to pay the amount of any overdraft, we reserve
                      the right to refer your overdrawn account to an attorney
                      for collection, and you agree to pay all reasonable
                      expenses, including, but not limited to, reasonable
                      attorney’s fees and court costs incurred by us as a result
                      of your account being overdrawn.
                    </li>
                  </ol>
                </li>
                <li>
                  <strong>Check cashing</strong>. We do not cash checks for you
                  or checks written by you. There are no physical branches
                  associated with this Account. Bank branches cannot be utilized
                  for check cashing or servicing related to this Account.
                </li>
                <li>
                  <strong>Virtual Card Payments</strong>. If you own a
                  Commercial Account, you may use a virtual commercial debit
                  card issued by Sutton Bank, headquartered in Ashland, Ohio,
                  through the Visa network (the “Virtual Card”) to make payments
                  to third parties. The use of Virtual Cards is subject to the
                  Payment Services Terms and Conditions and the Cardholder
                  Agreement accessible{" "}
                  <a href="https://prioritycommerce.com/enterprise-payments/passport/legal-terms/">
                    here
                  </a>
                  . By using the Virtual Card, you agree that you will be bound
                  by the terms of the Payment Services Terms and Conditions and
                  the Cardholder Agreement.
                </li>
                <li>
                  <strong>Payment of Fees</strong>. Except as set forth below,
                  any Fees and other amounts that are payable to us according to
                  this Agreement are due able payable when the applicable
                  statement is made available to you as set forth in Section
                  1.10 and will be deducted from your Passport Account as set
                  forth in Section 3.1. Debit Card Fees and Faster Funding Fees
                  (if applicable), however, are due and payable as soon as the
                  Debit Card is used or an Instant Funding is made,
                  respectively, and will be debited from your Commercial
                  Account.
                </li>
                <li>
                  <strong>Right of Setoff and Security Interest</strong>. If
                  your Passport Account balance becomes negative, or if your
                  Passport Account has insufficient funds to cover the Transfer
                  Service fees, any refunds, Chargebacks, Processing Fees, and
                  other amounts payable by you to us pursuant to any agreement
                  you have with us for any services involving the Passport
                  Account, in addition to any other rights we have as set forth
                  in this document, we can set off any unpaid balance of such
                  amounts against the funds in your External Accounts. You
                  hereby expressly authorize us to ACH debit your External
                  Account for any unpaid amount you owe us without any prior
                  notification. Moreover, we have the right to set-off any
                  liability, direct or contingent, past, present or future that
                  you owe against any External Account. We may take or set off
                  funds in any or all of your Accounts with us for direct,
                  indirect and acquired obligations that you owe us, to the
                  extent permitted by law. We may use funds held in your
                  Accounts to repay your obligations to us, including
                  obligations on which you are secondarily liable and any
                  amounts for which we become liable to any governmental agency
                  or department or any company as a result of recurring payments
                  credited to any of your Accounts after the dissolution, death,
                  legal incapacity or other termination of the intended
                  recipient of such funds. If you are a sole proprietor, we may
                  charge any of your Consumer or Commercial Accounts. If the law
                  imposes conditions or limits on our ability to take or set off
                  funds in your Account, to the extent that you may do so by
                  contract, you waive those conditions and limits and you
                  authorize us to apply funds in any or all of your Accounts
                  with us to obligations that you owe us. Some government
                  payments may be protected from attachment, levy or other legal
                  process under federal or state law. If such protections may
                  apply, to the extent that you may do so by contract, you waive
                  these protections and agree that we may take or set off funds,
                  including federal and state benefit payments, from your
                  Accounts to pay any obligations that you owe us. We may take
                  or set off funds from your Account before we pay checks or
                  other items drawn on the Account. We are not liable to you for
                  dishonoring items where our action results in insufficient
                  funds in your Account to pay your checks and other items. Our
                  setoff rights are in addition to other rights we have under
                  this Agreement to take or charge funds in your Account for
                  obligations you owe us. This section does not limit or reduce
                  our rights under applicable law to charge or set off funds in
                  your accounts with us for direct, indirect and acquired
                  obligations you owe us. Further, you grant us a lien on and
                  security interest in the funds on deposit in your Passport
                  Account as security for all of your liabilities and
                  obligations to us, now or in the future.
                </li>
                <li>
                  <strong>Concentration and Target Balance Accounts</strong>.
                  You may choose to designate one or more of your Accounts as a
                  master deposit account (a “Concentration Account”) and
                  designate one or more other Accounts as target balance
                  accounts with a predetermined target balance (each, a “Target
                  Balance Account” or “TBA”). When checks drawn or payment
                  instructions made (each an “Item” and collectively “Items”) on
                  a TBA are presented for payment, funds will be automatically
                  transferred from the Concentration Account to the TBA to cover
                  exactly the total amount of the Items. Deposits made to TBAs
                  are automatically transferred to the Concentration Account.
                  Each Business Day, we will transfer funds from the
                  Concentration Account to each TBA or from each TBA to the
                  Concentration Account, as appropriate, so that the ledger
                  balance in each TBA at the close of business is the
                  predetermined target amount. If there are not sufficient funds
                  in the Concentration Account to cover a predetermined target
                  amount on a TBA, transfers will only be made up to the amount
                  of the funds available in the Concentration Account. You
                  authorize us to execute the funds transfers to or from the
                  designated TBA(s) and Concentration Account(s). We will keep
                  the TBA open even if the predetermined target balance is zero.
                  We shall not be required to make any transfer from the
                  Concentration Account in excess of the funds therein, and in
                  the event that there are not sufficient collected funds in the
                  Concentration Account to make all of the transfers required,
                  we may allocate the funds among your designated TBAs in our
                  sole and absolute discretion. You shall maintain sufficient
                  available balances in the Concentration Account to cover the
                  amounts transferred by us. If the amount of funds available
                  for transfer from the Concentration Account or the amount of
                  funds available above the predetermined target amount in the
                  TBA is not sufficient to pay all Items presented for payment
                  on any given Business Day, we may return the Items for
                  insufficient funds. You acknowledge that deposits to the
                  Concentration Account(s) and/or TBA(s) may not be made
                  available to you until the funds in the deposit are collected,
                  whether or not such funds are transferred to another deposit
                  account in connection with other Transfer Services. We
                  determine when funds deposited are made available. You may
                  issue Items drawn on a TBA in excess of the balance in such
                  Account, provided, however, that the aggregate amount of all
                  such Items and other authorized debits to all of the TBA(s) do
                  not exceed the available balance in the Concentration
                  Account(s). In the event that the amount of such Items and
                  debits exceed such balance, we may, at our sole and absolute
                  discretion, return or refuse any such Item or debit, impose
                  any fee and take any other action authorized under any of our
                  agreements with you. If we elect to pay such check or debit
                  and an overdraft results, you agree to repay the amount of the
                  overdraft and any associated fee(s) to us at once.
                </li>
              </ol>
            </li>
            <li>
              <strong>General Funds Availability</strong>
              <ol>
                <li>
                  <strong>Your Ability To Withdraw Funds</strong>
                  <p>
                    Our policy is to make funds from your direct deposits,
                    incoming wire transfers, and ACH credit transfers available
                    to you on the day we receive the deposit. Funds are
                    “received” when they have been finally and actually
                    collected by us and when we have received information from
                    the payor regarding the Account and the amount to be
                    credited with such funds. Once they are available, you can
                    withdraw the funds in cash and we will use the funds to
                    cover your transactions.
                  </p>
                  <p>
                    For determining the availability of your deposits, every day
                    is a business day, except Saturdays, Sundays, and federal
                    holidays. If you make a deposit before our established
                    cut-off time for the type of deposit on a business day that
                    we are open, we will consider that day to be the day of your
                    deposit. However, if you make a deposit after our
                    established cut-off time for the type of deposit or on a day
                    we are not open, we will consider that the deposit was made
                    on the next business day we are open.
                  </p>
                </li>
                <li>
                  <strong>Faster Funding</strong>. If the Faster Funding
                  function is made available on Passport, if you are a merchant
                  and use your Passport Account as your merchant processing
                  settlement account, for any credit and debit transactions
                  authorized using Priority’s MX
                  <sup>TM</sup> gateway through the Passport application
                  programming interface (“API”), the settlement funds for such
                  credit and debit card transactions will be available in your
                  Commercial Account upon authorization and sales capture (the
                  “Faster Funds”). Once the Faster Funds are deposited in your
                  Commercial Account, you may use the Faster Funds to make
                  payments using the Bill Pay service (if available) or your
                  debit card without any limitation. But if you want to transfer
                  any Faster Funds to your external bank account (“Instant
                  Funding”), you may only transfer up to $10,000 during the
                  first twenty-four hours. The Instant Funding Fee set forth in
                  the Fee Schedule will apply to such external transfer. The
                  Faster Funds may be withdrawn from the Passport Account
                  without any limitation after three (3) business days.
                </li>
                <li>
                  <strong>Longer Availability</strong>. Electronic transfers
                  depositing into the Passport Account may take up to five (5)
                  business days from the date of the initial request but will
                  post on the payment date of the deposit once the money has
                  reached us.{" "}
                </li>
                <li>
                  <strong>Availability of Mobile Deposits. </strong>Checks
                  deposited through the RDC service are not subject to the funds
                  availability requirements of Regulation CC. Checks deposited
                  using the RDC service will generally be made available in your
                  Passport Account no later than six (6) business days after the
                  day you made the deposit unless a shorter period is required
                  by law. In some cases and to the extent permitted by law, we
                  may not make the funds available in accordance with the
                  general policy for other reasons, including, but not limited
                  to, if (i) we believe a deposited check will not be paid; (ii)
                  you deposit one or more checks totaling $5,000 or more in one
                  day; (iii) you redeposit a check that has been previously
                  returned unpaid; (iv) your Passport Account had a negative
                  balance anytime in the previous six (6) months; or (v) we
                  experience an emergency, such as failure of communication or
                  computer delays. The length of the delay will be counted in
                  business days from the day of your deposit. We will notify you
                  if we delay your availability to withdraw funds and we will
                  tell you when the funds will be available for withdrawal no
                  later than the seventh (7<sup>th</sup>) business day after the
                  day of your deposit. If your deposit is declined, we will
                  email you the notice by the first business day after the day
                  we receive your deposit. We reserve the right to change the
                  limits on the amount(s) and/or number of deposits that you
                  transmit using RDC and may modify these limits from time to
                  time.
                </li>
              </ol>
            </li>

            <li>
              <strong>ELECTRONIC FUNDS TRANSFER DISCLOSURES</strong>
              <ol>
                <li>
                  <strong>Electronic Transfers via ACH</strong>. You may
                  originate transfers to and from your Passport Account via ACH
                  as provided in Section 3 of this Agreement. These requests
                  must be made via the Passport Website. In the case of
                  electronic transfer requests from an external bank account to
                  your Passport Account, we will complete such requests only if
                  the funds are being transferred from your linked External
                  Account. ACH transactions are subject to Section 4 of the
                  Payments Terms and Conditions set forth{" "}
                  <a href="https://prioritycommerce.com/enterprise-payments/passport/legal-terms/">
                    here
                  </a>
                  . If you are a party to an ACH entry, you agree to be bound by
                  such terms and conditions and the National Automated Clearing
                  House Association (“NACHA”) Operating Rules, the Rules or any
                  local Automated Clearing House, and the Rules of any other
                  system through which the entry is made. The credit we give you
                  is provisional until we receive final settlement for that
                  entry. If we do not receive final settlement, you agree that
                  we are entitled to a refund of the amount credited to you in
                  connection with the entry, and the party making payment to you
                  via such entry (i.e., the originator of the entry) shall not
                  be deemed to have paid you in the amount of such entry. We
                  will not provide you with a notice of our receipt of the
                  order, unless we are so requested by the transfer originator
                  in the order. However, we will continue to notify you of the
                  receipt of payments in the periodic statements we provide to
                  you. We may accept on your behalf payments to your Account
                  which have been transmitted, that are not subject to the EFTA,
                  and your rights and obligations with respect to such payments
                  shall be construed in accordance with and governed by federal
                  law and the laws of the State of Georgia.
                  <ol>
                    <li>
                      Next Day ACH. Cut-off Time. The cut-off time for
                      scheduling a next day ACH transfer is 4:00 p.m. Eastern
                      Time. Any next day ACH transfer scheduled after the
                      cut-off time will be treated as if it were scheduled on
                      the next business day. In some circumstances, transactions
                      may be delayed for risk or compliance reasons.
                    </li>
                    <li>
                      Same Day ACH. Cut-off Time<em>. </em>The cut-off time for
                      scheduling same day ACH transfers (if enabled for your
                      Passport Account) is 9:00 a.m. Eastern Time. If enabled by
                      Priority, the Same Day ACH means that the transfer will be
                      performed within one (1) business day. Any same day ACH
                      transfer scheduled after the cut-off time will be treated
                      as if it were scheduled as next business day ACH transfer.
                      In some circumstances, transactions may be delayed for
                      risk or compliance reasons.
                    </li>
                  </ol>
                </li>
                <li>
                  <strong>
                    Electronic Transfers Using Your Passport Account Number
                  </strong>
                  . If enabled by Priority, you may authorize a third party to
                  transfer funds to and from your Passport Account by providing
                  your account number and your routing number to such third
                  party. Your account information should only be provided to
                  trusted third parties authorized to initiate the electronic
                  funds transfers. This function, even if enabled, may not be
                  available for all Account types.{" "}
                </li>
                <li>
                  <strong>Debit Cards and ATM Services</strong>. If enabled for
                  your Passport Account, you may obtain a debit card linked to
                  your Passport Account that can be used for purchases on points
                  of sales and/or withdrawals at ATMs. The use of your debit
                  card to initiate electronic transfers is subject to the term
                  and conditions of the applicable{" "}
                  <a href="https://prioritycommerce.com/enterprise-payments/passport/legal-terms/">
                    Cardholder Agreement
                  </a>
                  . By using the debit card, you agree that you will be bound by
                  the terms of the Cardholder Agreement. This function, even if
                  enabled, may not be available for all Account types.
                </li>
                <li>
                  <strong>Types of Electronic Transfers Available</strong>.
                  <ol>
                    <li>
                      You may arrange with another party to electronically
                      deposit funds on a one-time or recurring basis directly to
                      your Passport Account.
                    </li>
                    <li>
                      You may arrange with another party to make one-time or
                      recurring charges to your Passport Account to make
                      payments.
                    </li>
                    <li>
                      To make payments from your Passport Account, you may
                      provide payment instructions to Priority through a secured
                      API provided by Priority, by direct input onto Passport,
                      or by another secured method provided by Priority.
                    </li>
                  </ol>
                </li>
                <li>
                  <strong>
                    Limitations on Transfers, Amounts and Frequency
                  </strong>
                  . Your right to make electronic funds transfers is subject to
                  the limits established in Section 3 of this Agreement and in
                  the applicable Rate Sheet.
                </li>
                <li>
                  <strong>
                    Right to Receive Documentation of Electronic Funds Transfers
                  </strong>
                  . Your electronic funds transfers will be reflected on the
                  statements that will be delivered to you through the Passport
                  Website, as described in Section 1.10. You can also contact
                  Priority as provided in Section 6.10 to obtain information
                  about any particular direct deposit or transfer.
                </li>
                <li>
                  <strong>
                    Right to Stop Payment of One-Time Transfers and Procedures.
                  </strong>{" "}
                  For one-time ACH transfers scheduled via the Passport Website,
                  you may stop or cancel that transfer by following the
                  procedures set forth here.
                  <ol>
                    <li>
                      To stop a one-time ACH transfer you initiated via the
                      Passport Website, use the Passport Website to cancel such
                      payment. If you are unable to cancel or stop the payment
                      via the Passport Website, please contact Priority as
                      provided in Section 6.10 to request cancellation of the
                      transfer.{" "}
                    </li>
                    <li>
                      If you contact us either verbally or in writing, we will
                      stop the payment as long as we have a reasonable
                      opportunity to do so. You must specify the name of the
                      payee, the dollar amount of the payment and the date of
                      the payment. If you give us incorrect or insufficient
                      information, we will not be liable for failing to stop
                      payment on the item or authorization. If we honor such a
                      stop payment request, we do so without any liability or
                      responsibility to any party having any interest in the
                      entry. The stop order will remain in effect until either
                      you revoke it or the ACH is returned.
                    </li>
                    <li>
                      We may require you to provide us written confirmation of a
                      verbal stop order request against an ACH within fourteen
                      (14) calendar days. We will tell you about this
                      requirement at the time of a verbal request and provide an
                      address to which the written confirmation can be sent. If
                      the written stop payment notification is not received
                      within fourteen (14) days of a verbal stop order request,
                      the payment in question may be honored as originally
                      authorized. In such cases, we will not be liable if we do
                      not refuse payment.
                    </li>
                  </ol>
                </li>
                <li>
                  <strong>
                    Right to Stop Payment of Preauthorized Transfers and
                    Procedures.{" "}
                  </strong>
                  If you have scheduled a recurring ACH transfer via the
                  Passport Website, you may stop or cancel that transfer by
                  following the procedures set forth here.
                  <ol>
                    <li>
                      To stop a preauthorized ACH transfer you initiated via the
                      Passport Website, use the Passport Website to cancel such
                      payment. If you are unable to cancel or stop the payment
                      via the Passport Website, please contact Priority as
                      provided in Section 6.10 to request cancellation of the
                      transfer.{" "}
                    </li>
                    <li>
                      To stop a recurring transfer that you have authorized a
                      third party to debit, you may contact that third party to
                      request the cancellation of the recurring payment. For
                      Commercial Accounts, if the third party is unable or
                      unwilling to stop the transfer, please contact Priority as
                      provided in Section 6.10 to request a stop on the payment.
                      For Consumer Accounts, you may contact us regardless of
                      whether the third-party is unable or unwilling to stop the
                      transfer.
                    </li>
                    <li>
                      If you wish to stop a recurring transfer, your request to
                      stop the transfer must be received at least three (3)
                      business days before the transfer is scheduled to occur.
                      You should specify whether you wish to stop one recurring
                      payment or all recurring payments. You must specify the
                      name of the payee, the dollar amount of the payment and
                      the date of the payment. If you give us incorrect or
                      insufficient information, we will not be liable for
                      failing to stop payment on the item or authorization. We
                      will be liable for your direct losses or damages if you
                      requested the stop payment at least three (3) business
                      days before the transfer was scheduled to occur and we did
                      not stop the payment. If we honor such a stop payment
                      request, we do so without any liability or responsibility
                      to any party having any interest in the entry. A stop
                      payment order against an ACH transfer is effective until
                      the earlier of the time: (i) you withdraw the stop payment
                      order, or (ii) the debit entry is returned, or, where a
                      stop payment order is applied to more than one debit entry
                      under a specific authorization involving a specific party,
                      all such debit entries are returned. A stop payment order
                      may lapse six (6) months from the date the stop payment
                      order was requested. In some circumstances the stop
                      payment order may remain in effect longer than six months.
                    </li>
                    <li>
                      We may require you to provide us written confirmation of a
                      verbal stop order request against an ACH within fourteen
                      (14) calendar days. Additionally, if you request us to
                      stop all future payments pursuant to a specific ACH
                      authorization involving a particular party, we may require
                      you to confirm in writing that you have revoked such
                      authorization. If the written stop payment notification is
                      not received within fourteen (14) days of a verbal stop
                      order request, the payment in question may be honored as
                      originally authorized and future payments may not be
                      permanently stopped. In such cases, we will not be liable
                      if we do not refuse payment.
                    </li>
                  </ol>
                </li>
                <li>
                  <strong>
                    Commercial Accounts Only: Your Liability for Unauthorized
                    Transfers
                  </strong>
                  . Commercial Passport Accounts do not provide consumer
                  protections for unauthorized transactions or unauthorized
                  access to your Passport Account, including by way of lost or
                  stolen Passport Account numbers.{" "}
                  <strong>
                    Until an Account Owner, an Authorized Signer, or an
                    Authorized User reports a Passport Account number as lost or
                    stolen or reports an unauthorized transaction, Account Owner
                    is fully responsible for all transactions
                  </strong>
                  . Contact customer service IMMEDIATELY if an Authorized Signer
                  or Authorized User believes: (a) a Passport Account number has
                  been lost or stolen, (b) someone has gained unauthorized
                  access to any information to access the Passport Account, or
                  (c) someone has transferred or may transfer funds from the
                  Passport Account without an Authorized Signer’s permission.
                  Reporting a lost/stolen Passport Account number or
                  unauthorized transactions by contacting Priority as provided
                  in Section 6.10 or by logging into the Passport Website is the
                  best way to minimize possible losses. Account Owner are
                  responsible for all unauthorized transactions initiated and
                  fees incurred from the unauthorized use of the Passport
                  Account. Failure to promptly notify us could result in the
                  Account Owner losing ALL of the money in the Passport Account.
                  <ol>
                    <li>
                      You are responsible for all transactions initiated and
                      fees incurred by any use of the Commercial Passport
                      Account. If an Authorized Signer permits another person to
                      have access to Passport Account, we will treat this as if
                      Authorized Signer has authorized such person to use the
                      Passport Account, and you will be liable for all
                      transactions and fees incurred by such person, even if
                      they exceed the authorization granted. You will further be
                      responsible for any transactions made and any fees
                      incurred by the Authorized Signer even if the Authorized
                      Signer exceeds the scope of the authority granted to such
                      Authorized Signer by you. If you want to withdraw
                      permission for an Authorized Signer to use the Passport
                      Account, then transactions made with the Passport Account
                      will be considered unauthorized only after you notify us
                      that the person is no longer authorized to use the
                      Passport Account.
                    </li>
                  </ol>
                </li>
                <li>
                  <strong>Errors and Disputes</strong>. If you think your
                  statement is wrong or if you need more information about a
                  transaction listed on it, please contact Priority as provided
                  in Section 6.10. In making such communication, you need to
                  tell us: (i) your name and the Passport Account number; (ii)
                  why you believe there is an error or why you need more
                  information and the dollar amount involved; and (iii)
                  approximately when the error took place. To the extent
                  permitted by law, the periodic statement will be considered
                  correct for all purposes unless you contact customer service
                  in writing or by phone as provided in Section 6.10 within
                  certain time limits after the statement is made available to
                  you.{" "}
                  <ol>
                    <li>
                      <strong>For Commercial Accounts</strong>, we will review
                      the information submitted in a commercially reasonable
                      manner, but you are not entitled to and we are not
                      obligated to follow the requirements or obligations of the
                      Electronic Funds Transfer Act and Regulation E promulgated
                      thereunder, which only apply to consumer transfers.{" "}
                    </li>
                    <li>
                      <strong>For Consumer Accounts</strong>, contact us as
                      provided in Section 6.10 as soon as you can, if you think
                      your statement or receipt for any electronic transfers is
                      wrong or if you need more information about a transfer
                      listed on the statement or receipt. We must hear from you
                      no later than 60 days after we sent the FIRST statement on
                      which the problem or error appeared.
                      <ol className="parenthesis">
                        <li>Tell us your name and account number (if any).</li>
                        <li>
                          Describe the error or the transfer you are unsure
                          about, and explain as clearly as you can why you
                          believe it is an error or why you need more
                          information.
                        </li>
                        <li>
                          Tell us the dollar amount of the suspected error.
                          <p>
                            If you tell us orally, we may require that you send
                            us your complaint or question in writing within ten
                            (10) business days.
                          </p>
                          <p>
                            We will determine whether an error occurred within
                            10 business days after we hear from you and will
                            correct any error promptly. If we need more time,
                            however, we may take up to 45 days to investigate
                            your complaint or question. If we decide to do this,
                            we will credit your account within 10 business days
                            for the amount you think is in error, so that you
                            will have the use of the money during the time it
                            takes us to complete our investigation. If we ask
                            you to put your complaint or question in writing and
                            we do not receive it within 10 business days, we may
                            not credit your account.
                          </p>
                          <p>
                            For errors involving new accounts, point-of-sale, or
                            foreign-initiated transactions, we may take up to 90
                            days to investigate your complaint or question. For
                            new accounts, we may take up to 20 business days to
                            credit your account for the amount you think is in
                            error.
                          </p>
                          <p>
                            We will tell you the results within three business
                            days after completing our investigation. If we
                            decide that there was no error, we will send you a
                            written explanation. You may ask for copies of the
                            documents that we used in our investigation. If you
                            need more information about our error resolution
                            process, contact customer service as provided in
                            Section 6.10.
                          </p>
                        </li>
                      </ol>
                    </li>
                    <li>
                      <strong>
                        If the error involves an electronic fund transfer for a
                        Consumer Account
                      </strong>
                      : Tell us AT ONCE if you believe any debit card associated
                      with the Account has been lost or stolen, or if you
                      believe that an electronic fund transfer has been made
                      without your permission. Telephoning is the best way of
                      keeping your possible losses down. You could lose all the
                      money in your Account. If you tell us within 2 business
                      days after you learn of the loss or theft of your card,
                      you can lose no more than $50 if someone used your card
                      without your permission.
                      <p>
                        If you do NOT tell us within 2 business days after you
                        learn of the loss or theft of your card, and we can
                        prove we could have stopped someone from using your card
                        without your permission if you had told us, you could
                        lose as much as $500.
                      </p>
                      <p>
                        Also, if your statement shows transfers that you did not
                        make, including those made by card, code or other means,
                        tell us at once. If you do not tell us within 60 days
                        after the statement was mailed to you, you may not get
                        back any money you lost after the 60 days if we can
                        prove that we could have stopped someone from taking the
                        money if you had told us in time. If a good reason (such
                        as a long trip or a hospital stay) kept you from telling
                        us, we will extend the time periods.
                      </p>
                      <p>
                        If you believe your card has been lost or stolen,
                        contact us using the information provided in Section
                        6.10.{" "}
                      </p>
                    </li>
                  </ol>
                </li>
                <li>
                  <strong>
                    Our Liability for Failure to Complete Transactions
                  </strong>
                  . If we do not complete a transfer to or from your Passport
                  Account on time or in the correct amount according to our
                  Agreement with you, we will be liable for your losses or
                  damages. However, there are some exceptions. In addition to
                  other exceptions stated in this Agreement or as provided by
                  laws, we will not be liable, for instance, if:
                  <ol className="parenthesis-roman parenthesis">
                    <li>
                      through no fault of ours, you do not have enough money in
                      your Account to make the transfer;{" "}
                    </li>
                    <li>
                      the ATM or device does not have enough cash or is not
                      working properly;{" "}
                    </li>
                    <li>
                      circumstances beyond our control (such as fire or flood)
                      prevent the transfer, despite reasonable precautions that
                      we have taken;{" "}
                    </li>
                    <li>
                      for Commercial Accounts, the merchant requests
                      authorization for an amount greater than the purchase
                      amount;{" "}
                    </li>
                    <li>
                      access to your Passport Account or linked account has been
                      blocked after you reported your Passport Account number or
                      linked account number lost or stolen;{" "}
                    </li>
                    <li>
                      we have reason to believe the requested transaction is
                      unauthorized; or
                    </li>
                    <li>
                      we have received unclear, incomplete or inaccurate payment
                      instruction or information from you or the third-party
                      payor or payee.
                    </li>
                  </ol>
                  <p>
                    Also, we are not liable for the failure to complete a
                    transaction on a Commercial Account if we send you notice
                    that the transaction was not completed.
                  </p>
                </li>
                <li>
                  <strong>
                    Special Provisions for Merchants; Authorization
                  </strong>
                  . If you are a merchant of Priority, you may elect to use your
                  Passport Account as your settlement account by checking the
                  appropriate box in your application in the account opening
                  process or on your Account portal. By electing to use your
                  Passport Account as your settlement account, you authorize us
                  to initiate debit and credit entries and adjustments, as well
                  as any entries in error, to such Passport Account. This
                  authorization will stay in effect until the earlier of (i)
                  your written notice to Priority that you are changing the
                  settlement account pursuant to your Merchant Agreement; or
                  (ii) your Merchant Agreement has terminated, and all monies
                  due under such Merchant Agreement have been paid in full.
                </li>
              </ol>
            </li>

            <li>
              <strong>GENERAL RULES GOVERNING THE ACCOUNT</strong>
              <ol>
                <li>
                  <strong>
                    Assignment. Transfer. Non-Waiver. Applicable law
                  </strong>
                  . The Passport Account and your obligations under this
                  Agreement may not be assigned. You may not pledge the Account
                  or any Account funds, and any such pledge remains subject to
                  any right we have under this Agreement, other agreements with
                  you and applicable state and federal law. If ownership is
                  proposed to be transferred, we may require the Account be
                  closed and a new account opened in the name of the transferee
                  or pledgee. We may transfer our rights under this Agreement.
                  Use of the Passport Account is subject to applicable Federal
                  laws and the laws of the State of Georgia, and all applicable
                  rules and customs of any clearinghouse or other association
                  governing your Passport Account or any transactions. If you or
                  we excuse each other from complying with any part of this
                  Agreement, this will not waive compliance by the excused party
                  on any other occasion, notwithstanding the number of previous
                  excusals or their duration. A party may not rely justifiably
                  upon another’s past forbearance to vary present or future
                  rights, obligations or performance under this Agreement. If
                  any provision of this Agreement (except the Arbitration
                  Agreement in Section 16.12 below) is determined to be invalid,
                  illegal or unenforceable for any reason, that provision shall
                  not invalidate or render unenforceable any other provision of
                  this Agreement. If feasible, any such offending provision
                  shall be deemed to be modified to be within the limits of
                  enforceability or validity; however, if the offending
                  provision cannot be so modified, it shall be stricken and all
                  other provisions of the Agreement in all other respects shall
                  remain valid and enforceable.
                </li>
                <li>
                  <strong>Legal Action Affecting Passport Accounts</strong>. If
                  we are served with a subpoena, government agency request for
                  information, restraining order, writ of attachment or
                  execution, levy, garnishment, search warrant, forfeiture or
                  similar order or legal process relating to your Passport
                  Account (termed “legal action” in this section) we may act
                  upon such legal action if we reasonably believe that it is
                  binding, with no liability to you for doing so. You may have
                  rights to contest such action on your own behalf under the
                  applicable law. If you and/or your Account become involved in
                  any legal action, your use of the Account may be restricted.
                  In response to any garnishment, attachment, restraining order,
                  injunction, levy, citation to discover assets, judgment,
                  reclamation, other order of court or other legal action, we
                  may place a hold on, remove from your Account and/or remit to
                  the designated third party or parties any amount on deposit in
                  your Account as set forth in and required by such legal
                  action, subject to our right of setoff. In addition, if any
                  third party claims any right to the funds in your Account, or
                  you and we dispute our respective right to the funds in your
                  Account, we may institute an appropriate interpleader action
                  in any federal or state court located in Fulton County,
                  Georgia, to determine the rights of the parties involved with
                  regard to such funds. In such event, the funds in dispute will
                  be deposited with the court, and we shall be relieved of and
                  discharged from any and all obligations and liabilities under
                  and pursuant to this Agreement with respect to such funds. In
                  these cases, we will not have any liability to you if there
                  are insufficient funds to pay your items because we have
                  withdrawn funds from your Passport Account or in any way
                  restricted access to your funds in accordance with the legal
                  action. Any fees or expenses we incur in responding to any
                  legal action (including, without limitation, attorneys’ fees
                  and our internal expenses) may be charged against your
                  Passport Account. Unless expressly prohibited by law, we will
                  charge your Passport Account a fee for each legal action
                  received as set forth in the Fee Schedule, regardless of
                  whether the legal action is subsequently revoked, vacated or
                  released. If the legal action directs us to release
                  information about one or more, but not all, Accounts that are
                  reported on a combined statement, we may release the entire
                  combined statement, even though other Accounts reported on the
                  combined statement are not covered by the legal action. If the
                  legal action requests information about one or more, but not
                  all, Account Owners or Authorized Signers, we may release
                  information about all Account Owners or Authorized Signers on
                  the Account, even though the Account Owner or some of the
                  Authorized Signers are not covered by the legal action.
                </li>
                <li>
                  <strong>Abandoned or Inactive Accounts</strong>. Georgia has
                  unclaimed property laws that govern when accounts are
                  considered abandoned. Your Passport Account is usually
                  considered abandoned if you have not made a deposit or
                  withdrawal, or signed in to your online Passport Account, for
                  five years. We are required by the unclaimed property laws to
                  turn over accounts considered abandoned to the applicable
                  state. Before we turn over an abandoned account, we may send a
                  notice to you by email or the address we show for the account
                  statement. Unless prohibited by law, we may charge to your
                  Passport Account our costs and expenses of any notice, payment
                  and turnover of the remaining balance of your Passport Account
                  to the applicable state. Georgia laws will apply to unclaimed
                  or abandoned property related to the Passport Account.
                </li>
                <li>
                  <strong>FDIC Insurance</strong>. Priority is a financial
                  technology company, not an FDIC-insured bank. FDIC insurance
                  only covers the failure of an FDIC-insured bank. FDIC
                  insurance up to $250,000 is available on customer funds
                  through pass-through insurance at Bank, Member FDIC where we
                  have a direct relationship for the placement of deposits and
                  into which customer funds are deposited, but only if certain
                  conditions have been met. There may be a risk that FDIC
                  insurance is not available because conditions have not been
                  satisfied. In such cases, funds may not be fully insured in
                  the event the insured depository institution where the funds
                  have been deposited were to fail.
                </li>
                <li>
                  <strong>Account Owner Representations and Warranties</strong>.
                  By requesting, activating or using a Passport Account or by
                  retaining, using or authorizing the use of the Passport
                  Account, you, as the Account Owner, represent and warrant to
                  us that:
                  <ol>
                    <li>
                      Account Owner has received a copy of this Agreement and
                      agrees to be bound by and to comply with them and
                      understands that they are subject to change in accordance
                      with applicable law.
                    </li>
                    <li>
                      For Commercial Accounts, (a) Account Owner is duly
                      organized, validly existing and in good standing under the
                      laws of the state in the United States of its formation;
                      (b) Account Owner is duly qualified and in good standing
                      to do business in all jurisdictions where Account Owner
                      conducts its business; (c) the individual accepting and
                      agreeing to this Agreement for Account Owner has the
                      requisite corporate authority to accept and agree to this
                      Agreement on the Account Owner’s behalf and to bind
                      Account Owner in accordance with the terms of this
                      Agreement; (d) each Authorized Signer designated by an
                      Account Owner is a citizen or permanent resident of the
                      United States and is at least 18 years of age (or older if
                      residing in a state where the majority age is older); (e)
                      Each Authorized Signer is authorized to accept and use the
                      Passport Account; (f) Account Owner has provided each
                      Authorized Signer with a copy of this Agreement and each
                      Authorized Signer accepts and agrees to be bound by and to
                      comply with this Agreement; and (g) the Passport Account
                      will only be used for business purposes and not be used
                      for personal, family or household purposes.
                    </li>
                    <li>
                      Account Owner has all necessary organizational power and
                      authority or legal capacity, as applicable, to establish
                      the Passport Account, enter into this Agreement, and to
                      perform all of the obligations to be performed by it under
                      this Agreement.
                    </li>
                    <li>
                      The personal and, for Commercial Accounts, business
                      information that Account Owner provides to us in
                      connection with the Passport Account is true, correct and
                      complete.
                    </li>
                  </ol>
                </li>
                <li>
                  <strong>Standard of Care. Limitation of Liability</strong>.
                  Our liability for losses you incur in connection with your
                  Passport Account is limited to actual damages proved that are
                  proximately caused by our failure to exercise ordinary care.
                  Nevertheless, if we make an error in your favor by excessively
                  crediting or insufficiently debiting your account for any
                  reason, including, without limitation, to the giving of cash
                  or credit in excess of a corresponding account debit, you
                  agree that you immediately owe us the amount in error, whether
                  you relied on the error or not. You agree to waive your rights
                  to a jury trial and to punitive and exemplary damages and
                  further agree to be subject to all parts of the arbitration
                  provision in Section 6.12. Damages for any breach of this
                  Agreement are limited to those that are direct when permitted
                  by law and lie in contract, and will exclude indirect and
                  consequential damages. Also excluded are damages in tort,
                  including but not limited to those for emotional distress,
                  unless caused by a willful and malicious act, which in the
                  case of the unauthorized disclosure of private or confidential
                  information must also be defamatory. In return, we also waive
                  our same rights in any such action, cross-action or claims in
                  arbitration we may file against you. We will have no liability
                  for acting on instructions from you accepted or interpreted by
                  us in good faith according to the terms of this Agreement,
                  declining to act on instructions whose authenticity or
                  accuracy cannot be verified to our satisfaction, or not acting
                  on instructions not actually received. Nothing in this Section
                  should be construed to limit our liability to the extent it
                  conflicts with any applicable law.
                  <ol>
                    <li>
                      Except as required by applicable law, we will have no
                      liability to you if we are unable to complete a
                      transaction for any reason beyond our control. Except as
                      otherwise expressly provided in this Agreement or as
                      otherwise required by applicable law, we, any affiliates,
                      and the parties with whom we and our affiliates contract
                      in order to offer your Passport Account and related
                      services are neither responsible nor liable for any
                      indirect, incidental, consequential, special, exemplary,
                      or punitive damages arising out of or relating in any way
                      to your Passport Account, any products or services
                      purchased using the Passport Account, or this Agreement
                      (as well as any related or prior agreement you may have
                      had with us).
                    </li>
                    <li>
                      By accepting this Agreement, you acknowledge that neither
                      Bank nor Priority will be liable for taking action for the
                      purpose of compliance with any applicable law or
                      regulation.
                    </li>
                  </ol>
                </li>
                <li>
                  <strong>Indemnification</strong>. To the extent permitted by
                  law, you shall indemnify and defend us, Bank and our
                  respective officers, directors, employees, agents, and
                  representatives, and hold each of them harmless, against suit,
                  judgment, asserted claim, demand, excise taxes, claims,
                  liabilities or losses, including fees of counsel, interest and
                  other expenses, arising directly or indirectly from your
                  breach of your obligations under this Agreement or those
                  arising from the instructions or actions of you or of third
                  parties whom you have permitted to direct, manage, view or
                  otherwise act or omit to act in connection with your Passport
                  Account. If we, Bank, and our respective officers, directors,
                  employees, agents or representatives are entitled to
                  indemnification against a claim under this Agreement, we shall
                  give you prompt notice of the claim and any further pleadings,
                  communication or other information connected with it. You
                  shall defend us, Bank, and our respective officers, directors,
                  employees, agents, and representatives, or pay for the cost of
                  its defense, as we, Bank, or our respective officers,
                  directors, employees, agents or representatives shall elect.
                  The parties shall cooperate for the cost-effective defense of
                  the claim, and us, Bank and our respective officers,
                  directors, employees, agents and representatives shall not
                  settle any claim for which indemnification is demanded without
                  your consent.
                </li>
                <li>
                  <strong>
                    No Warranty of Availability or Uninterrupted Use.{" "}
                  </strong>
                  From time to time, services related to the Passport Website or
                  the Passport Account may be inoperative. When this happens,
                  you may be unable to access the Passport Website, and you may
                  be unable to use the Passport Account or obtain information
                  about the Passport Account. Please notify us if you have any
                  problems using the Passport Account or Passport Website. You
                  agree that we will not be responsible for temporary
                  interruptions in service due to maintenance, website changes,
                  or failures, nor shall we be liable for extended interruptions
                  due to failures beyond our control, including but not limited
                  to the failure of interconnecting and operating systems,
                  computer viruses, forces of nature, labor disputes and armed
                  conflicts.
                </li>
                <li>
                  <strong>Amendment</strong>. Except as otherwise required by
                  applicable law, we may amend or change the terms and
                  conditions of this Agreement at any time by posting the
                  amended Agreement on the Passport Website, and any such
                  amendment will be effective upon such posting to the website.
                  You will be notified of any amendment(s) in the manner
                  provided by applicable law prior to the effective date of the
                  amendment(s). However, if the amendment(s) is made for
                  security purposes or your benefit, we may implement it without
                  prior notice.
                </li>
                <li>
                  <strong>Customer Service. </strong>For customer service or
                  additional information regarding your Passport Account, please
                  contact Priority at:
                  <div style={{ paddingLeft: "24px" }}>
                    <p>Phone: +1(800-475-0811)</p>
                    <p>
                      Email:{" "}
                      <a href="mailto:support@prioritypassport.com">
                        support@prioritypassport.com
                      </a>{" "}
                    </p>
                    <p>Mailing address:</p>
                    <p> Priority Technology Holdings, Inc.</p>
                    <p> 2001 Westside Parkway</p>
                    <p> Suite 155</p>
                    <p> Alpharetta, GA 30004</p>
                    <p> Attn: Customer Services</p>
                    <p>
                      Customer Service agents are available to answer your calls
                      at the following hours:
                    </p>
                    <p>
                      Eastern Time: Monday through Friday: 7:00 AM – 7:00 PM.
                    </p>
                  </div>
                </li>
                <li>
                  <strong>
                    Returned/Unclaimed Mail or Account Information
                  </strong>
                  . Unless otherwise prohibited by applicable law, this
                  subsection applies if one or more Account-related documents
                  are returned, or in the case of online statement email
                  notifications, the email notice is returned undeliverable. We
                  may discontinue sending Account-related information to you
                  until you provide a valid postal or electronic address to us.
                  Additionally, we may: (1) destroy Account-related information
                  that is sent to you and returned to us as undeliverable; and
                  (2) hold the Account-related information for your Account
                  until you contact us. If we hold Account-related information
                  for you and it remains unclaimed for 60 days, we may send the
                  Account-related information to the address reflected in our
                  records for your Account or destroy it.
                </li>
                <li>
                  <strong>CONSUMER ACCOUNT ARBITRATION AGREEMENT.</strong>
                  <p>
                    This Section 6.12 (the “Arbitration Agreement”) applies to
                    Consumer Accounts. If your Account is a Consumer Account,
                    this Arbitration Agreement is legally binding on you and us.
                    We have put this Arbitration Agreement in question and
                    answer form to make it easier to understand.
                  </p>

                  <p style={{ textAlign: "center" }}>
                    <strong>Background and Scope. </strong>
                  </p>
                  <table
                    style={{
                      border: "1px solid black",
                      borderCollapse: "collapse",
                    }}
                  >
                    <thead>
                      <tr>
                        <th
                          style={{
                            backgroundColor: "#e0e0e0",
                            color: "black",
                            textDecoration: "underline",
                            border: "1px solid black",
                            padding: "8px",
                          }}
                        >
                          <p>
                            <strong>Question</strong>
                          </p>
                        </th>
                        <th
                          style={{
                            backgroundColor: "#e0e0e0",
                            color: "black",
                            textDecoration: "underline",
                            border: "1px solid black",
                            padding: "8px",
                          }}
                        >
                          <p>
                            <strong>Short Answer</strong>
                          </p>
                        </th>
                        <th
                          style={{
                            backgroundColor: "#e0e0e0",
                            color: "black",
                            textDecoration: "underline",
                            border: "1px solid black",
                            padding: "8px",
                          }}
                        >
                          <p>
                            <strong>Further Detail</strong>
                          </p>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>
                            <strong>What is arbitration? </strong>
                          </p>
                        </td>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>An alternative to a court case. </p>
                        </td>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>
                            In arbitration, a neutral third party (a "
                            <strong>Neutral</strong>") resolves Claims in a
                            hearing without a jury.{" "}
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>
                            <strong>
                              Is it different from court and jury trials?{" "}
                            </strong>
                          </p>
                        </td>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>Yes. </p>
                        </td>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>
                            The hearing is private. There is no jury. It is
                            usually less formal, faster and less expensive than
                            a lawsuit. Pre-hearing fact finding is limited.
                            Appeals are limited. Courts rarely overturn
                            arbitration awards.{" "}
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>
                            <strong>
                              Can you opt out of this Arbitration Agreement?{" "}
                            </strong>
                          </p>
                        </td>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>Yes, within 60 days. </p>
                        </td>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>
                            If you do not want this Arbitration Agreement to
                            apply, you must send us a signed notice within 60
                            calendar days after the date you become subject to
                            this Arbitration Agreement. You must send the notice
                            in writing to legaldepartment@prth.com or 2001
                            Westside Parkway, Suite 155, Alpharetta, GA 30004
                            (or any subsequent address we provide to you) (the "
                            <strong>Notice Address</strong>"), Attn. Legal
                            Department. Provide your name, address and date.
                            State that you "opt out" of the Arbitration
                            Agreement.{" "}
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>
                            <strong>
                              What is this Arbitration Agreement about?{" "}
                            </strong>
                          </p>
                        </td>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>The parties' agreement to arbitrate Claims. </p>
                        </td>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>
                            Unless prohibited by applicable law and unless you
                            opt out, you and we agree that any party may elect
                            to arbitrate or require arbitration of any "
                            <strong>Claim</strong>" (as defined below).
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>
                            <strong>
                              Who does the Arbitration Agreement cover?{" "}
                            </strong>
                          </p>
                        </td>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>You, us, and certain related parties. </p>
                        </td>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>
                            This Arbitration Agreement governs you (as the
                            Account Owner of a Consumer Account) and us.
                            <strong> </strong>
                            Solely as used in this Arbitration Agreement, the
                            words "we," "us" and "our" mean: (1) Priority, Bank
                            (as defined in your Passport Account Agreement), and
                            Sutton Bank (as defined in your Cardholder
                            Agreement); (2) their parent companies,
                            subsidiaries, affiliates, assignees and successors;
                            (3) the employees, directors, officers,
                            shareholders, members and representatives of the
                            companies referenced in items (1) and (2); and (4)
                            any person or company that is named in a Claim you
                            pursue at the same time you pursue a related Claim
                            against any company or person referenced in items
                            (1)-(3).{" "}
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>
                            <strong>
                              What Claims does the Arbitration Agreement cover?{" "}
                            </strong>
                          </p>
                        </td>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>
                            All Claims (except certain Claims about this
                            Arbitration Agreement).{" "}
                          </p>
                        </td>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>
                            This Arbitration Agreement governs all "
                            <strong>Claims</strong>" that would usually be
                            decided in court and are between us and you. In this
                            Arbitration Agreement, the word "
                            <strong>Claims</strong>" has the broadest reasonable
                            meaning. It includes contract and tort claims
                            (including fraud and intentional tort claims) and
                            claims under constitutions, statutes, ordinances,
                            rules and regulations. It includes all claims
                            directly and indirectly related to your Passport
                            Account, Passport Account Agreement, Cardholder
                            Agreement, the Passport Website, any services we
                            provide to you, and our relationship with you. It
                            includes claims related to marketing, collections,
                            privacy and customer information.{" "}
                            <strong>
                              However, it does not include disputes about the
                              validity, coverage or scope of this Arbitration
                              Agreement or any part of this Arbitration
                              Agreement. All such disputes are for a court and
                              not the Neutral to decide.{" "}
                            </strong>
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <p style={{ textAlign: "center" }}>
                    <strong>Process. Arbitration Fees and Awards. </strong>
                  </p>
                  <table
                    style={{
                      border: "1px solid black",
                      borderCollapse: "collapse",
                    }}
                  >
                    <thead>
                      <tr>
                        <th
                          style={{
                            backgroundColor: "#e0e0e0",
                            color: "black",
                            textDecoration: "underline",
                            border: "1px solid black",
                            padding: "8px",
                          }}
                        >
                          <p>
                            <strong>Question</strong>
                          </p>
                        </th>
                        <th
                          style={{
                            backgroundColor: "#e0e0e0",
                            color: "black",
                            textDecoration: "underline",
                            border: "1px solid black",
                            padding: "8px",
                          }}
                        >
                          <p>
                            <strong>Short Answer</strong>
                          </p>
                        </th>
                        <th
                          style={{
                            backgroundColor: "#e0e0e0",
                            color: "black",
                            textDecoration: "underline",
                            border: "1px solid black",
                            padding: "8px",
                          }}
                        >
                          <p>
                            <strong>Further Detail</strong>
                          </p>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>
                            <strong>
                              Who administers the arbitration? What rules apply?
                            </strong>
                          </p>
                        </td>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>
                            Usually, the AAA administers arbitrations under its
                            rules.
                          </p>
                        </td>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>
                            Arbitrations will be conducted under this
                            Arbitration Agreement. Except for some group
                            arbitrations ("
                            <strong>Group Arbitrations</strong>") of common
                            issues of law or fact ("
                            <strong>Common Issues</strong>") conducted without
                            an arbitration administrator, as described below,
                            arbitrations will also be subject to the rules of
                            the arbitration administrator in effect at the time
                            the arbitration is commenced. However, arbitration
                            rules that conflict with this Arbitration Agreement
                            do not apply. The arbitration administrator (if any)
                            will be either: (1) the American Arbitration
                            Association ("<strong>AAA</strong>"), 1633 Broadway,
                            10th Floor, New York, NY 10019,{" "}
                            <a href="http://www.adr.org">www.adr.org</a>; or (2)
                            any other company picked by agreement of the
                            parties. If both of the above options are
                            unavailable, a court will pick the administrator (if
                            any).{" "}
                            <strong>
                              No arbitration brought on a class basis may be
                              administered or conducted without our consent by
                              any administrator or Neutral that would permit
                              class or representative arbitration under this
                              Arbitration Agreement.
                            </strong>{" "}
                          </p>
                          <p>
                            The Neutral will be selected under the rules of the
                            administrator (if any). However, the Neutral must be
                            a lawyer with at least ten years of experience or a
                            retired judge unless you and we otherwise agree.
                          </p>
                          <p>
                            We may waive any rights under this Arbitration
                            Agreement, either on our own or at your request.
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>
                            <strong>Can Claims be brought in court? </strong>
                          </p>
                        </td>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>Sometimes. </p>
                        </td>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>
                            Any party may bring a lawsuit if no other party
                            demands arbitration. Also, either you or we may
                            require that any individual Claim within the
                            jurisdiction of a small claims court shall be
                            resolved by such small claims court. However, any
                            party may demand arbitration of any appeal of a
                            small-claims decision or any small-claims action
                            brought on a class basis.<strong> </strong>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>
                            <strong>Are you giving up any rights? </strong>
                          </p>
                        </td>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>Yes.</p>
                        </td>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>
                            <strong>
                              For Claims subject to this Arbitration Agreement,
                              you give up your right to:{" "}
                            </strong>
                          </p>
                          <ol>
                            <li>
                              <strong>Have juries decide Claims.</strong>
                            </li>
                            <li>
                              <strong>
                                Have courts, other than small-claims courts,
                                decide Claims.
                              </strong>
                            </li>
                            <li>
                              <strong>
                                Serve as a private attorney general or in a
                                representative capacity (provided that public
                                injunction Claims may be litigated as provided
                                under the caption "What happens if part of this
                                Arbitration Agreement cannot be enforced?").
                              </strong>
                            </li>
                            <li>
                              <strong>
                                Without our consent (and except for Group
                                Arbitrations described below), join a Claim you
                                have with a claim by other consumers.{" "}
                              </strong>
                            </li>
                            <li>
                              <strong>
                                Bring or be a class member in a class action or
                                class arbitration.
                              </strong>
                            </li>
                          </ol>
                          <p>
                            <strong>We also agree to these limits. </strong>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>
                            <strong>
                              Can you or another consumer start class
                              arbitration?
                            </strong>
                          </p>
                        </td>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>No. </p>
                        </td>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>
                            <strong>
                              The Neutral is not allowed to handle any Claim on
                              a class or representative basis.{" "}
                            </strong>
                            This Arbitration Agreement will be void if a court
                            rules that the Neutral can decide a Claim on a class
                            or representative basis and the court's ruling is
                            not reversed on appeal.{" "}
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>
                            <strong>
                              What happens if part of this Arbitration Agreement
                              cannot be enforced?{" "}
                            </strong>
                          </p>
                        </td>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>It depends. </p>
                        </td>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>
                            If any portion of this Arbitration Agreement cannot
                            be enforced, the rest of this Arbitration Agreement
                            will continue to apply, except that:{" "}
                          </p>
                          <p>
                            (1) If a court rules that the Neutral can decide a
                            Claim on a class or other representative basis and
                            the court's ruling is not reversed on appeal, only
                            this sentence will apply and the remainder of this
                            Arbitration Agreement will be void; and{" "}
                          </p>
                          <p>
                            (2) If you bring a Claim seeking public injunctive
                            relief and a court determines that the restrictions
                            in this Arbitration Agreement prohibiting the
                            Neutral from awarding relief on behalf of third
                            parties are unenforceable with respect to such Claim
                            (and that determination becomes final after all
                            appeals have been exhausted), the Claim for public
                            injunctive relief will be determined in court and
                            any individual Claims seeking monetary relief will
                            be arbitrated. In such a case, the parties agree to
                            request that the court stay the Claim for public
                            injunctive relief until the arbitration award
                            pertaining to individual relief has been entered in
                            court.
                          </p>
                          <p>
                            <strong>
                              In no event will a Claim for class relief or
                              public injunctive relief be arbitrated, either
                              individually or in a Group Arbitration.
                            </strong>{" "}
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>
                            <strong>
                              In sum, what options do I have in order to assert
                              Claims against you?
                            </strong>
                          </p>
                        </td>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>
                            Subject to limited exceptions, most Claims are
                            subject to arbitration.
                          </p>
                        </td>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>
                            All Claims subject to this Arbitration Agreement
                            must be decided in: (1) an individual arbitration;
                            (2) a Group Arbitration of Common Issues; (3) a
                            lawsuit if (and only if) the defendant does not
                            demand arbitration; (4) an individual action in
                            small-claims court; or (5) a lawsuit that solely
                            addresses a Claim for public injunctive relief, but
                            only as provided under the caption "What happens if
                            part of this Arbitration Agreement cannot be
                            enforced?"
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>
                            <strong>What law applies? </strong>
                          </p>
                        </td>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>The Federal Arbitration Act ("FAA"). </p>
                        </td>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>
                            The Passport Account, Passport Account Agreement,
                            Cardholder Agreement, Passport Website, services we
                            provide, and this Arbitration Agreement involve
                            interstate commerce. Thus, the FAA governs this
                            Arbitration Agreement. The Neutral must apply
                            substantive law and comply with the FAA. The Neutral
                            must honor statutes of limitation and privilege
                            rights. Punitive damages are governed by the
                            constitutional standards that apply in judicial
                            proceedings.{" "}
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>
                            <strong>
                              Will anything I do make this Arbitration Agreement
                              ineffective?{" "}
                            </strong>
                          </p>
                        </td>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>No. </p>
                        </td>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>
                            This Arbitration Agreement stays in force even if
                            you: (1) close your Passport Account, surrender your
                            Consumer Card, and/or terminate the Passport Account
                            Agreement or Cardholder Agreement; (2) or go into or
                            through bankruptcy.{" "}
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>
                            <strong>
                              What must a party do before starting a lawsuit or
                              arbitration?{" "}
                            </strong>
                          </p>
                        </td>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>
                            Send a written Claim Notice and work to resolve the
                            Claim.{" "}
                          </p>
                        </td>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>
                            Before starting a lawsuit or arbitration, the
                            complaining party (the "<strong>Claimant</strong>")
                            must give the other party or parties (the "
                            <strong>Respondent</strong>") written notice of the
                            Claim (a "<strong>Claim Notice</strong>"). The Claim
                            Notice must explain in reasonable detail the nature
                            of the Claim, any supporting facts and the requested
                            relief. If you are the Claimant, you must send the
                            Claim Notice in writing (and not electronically) to
                            the Respondent, c/o Priority Technology Holdings,
                            Inc. at the Notice Address, Attn. Legal Department.
                            You or an attorney you have personally hired must
                            sign the Claim Notice and must provide your full
                            name and a phone number where you (or your attorney)
                            can be reached. A collections letter from us to you
                            will serve as a Claim Notice. Once a Claim Notice is
                            sent, the Claimant must give the Respondent a
                            reasonable opportunity over the next 30 days to
                            resolve the Claim on an individual basis.{" "}
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>
                            <strong>How does arbitration start? </strong>
                          </p>
                        </td>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>Per the administrator's rules. </p>
                        </td>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>
                            If the parties do not reach an agreement to resolve
                            a Claim within 30 days after notice of the Claim is
                            received, the Claimant may commence a lawsuit or
                            arbitration, subject to the terms of this
                            Arbitration Agreement. To start arbitration, the
                            Claimant must follow the administrator's rules. If a
                            Claimant begins or threatens a lawsuit, the
                            Respondent can demand arbitration. This demand can
                            be made in court papers. It can be made if a
                            Claimant begins a lawsuit on an individual basis and
                            then tries to pursue a class action. Once an
                            arbitration demand is made, no lawsuit may be
                            brought and any existing lawsuit must stop.{" "}
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>
                            <strong>Will any hearing be held nearby? </strong>
                          </p>
                        </td>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>Yes. </p>
                        </td>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>
                            The Neutral may decide that an in-person hearing is
                            unnecessary and that he or she can resolve a Claim
                            based on written filings and/or a conference call.
                            However, any in-person arbitration hearing must be
                            held at a place reasonably convenient to you.{" "}
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>
                            <strong>What about appeals? </strong>
                          </p>
                        </td>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>Very limited. </p>
                        </td>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>
                            Appeal rights under the FAA are very limited. Except
                            for: (1) FAA appeal rights; (2) Claims involving
                            more than $50,000 (including Claims involving
                            requests for injunctive relief that could cost more
                            than $50,000); and (3) Claims involving Common
                            Issues resolved in a Group Arbitration, the
                            Neutral's award will be final and binding. For
                            Claims involving more than $50,000 and Claims
                            involving Common Issues resolved in a Group
                            Arbitration, any party (including a majority of the
                            Claimants in a Group Arbitration) may appeal the
                            award to a three-Neutral panel selected in
                            accordance with this Arbitration Agreement, which
                            will reconsider from the start anything in the
                            initial award that is appealed. The panel's decision
                            will be final and binding, except for any FAA appeal
                            right. Any appropriate court may enter judgment upon
                            the Neutral's award.{" "}
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>
                            <strong>
                              Do arbitration awards affect other disputes?
                            </strong>
                          </p>
                        </td>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>No. </p>
                        </td>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>
                            You and we agree that no arbitration involving you
                            will have any effect on issues or claims in a
                            dispute we have with anyone who is not a party to
                            such arbitration (including the parties in a Group
                            Arbitration that does not involve you), nor will an
                            arbitration award in disputes that do not involve
                            you have any impact in an individual arbitration or
                            Group Arbitration involving you.{" "}
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>
                            <strong>Who bears arbitration fees? </strong>
                          </p>
                        </td>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>Usually, we do. </p>
                        </td>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>
                            Except for Group Arbitrations, we will agree to pay
                            all filing, administrative, hearing and Neutral fees
                            if you act in good faith, cannot get a waiver of
                            such fees and ask us to pay. We will always pay
                            these amounts if required under applicable law or
                            the administrator's rules or if payment is required
                            to enforce this Arbitration Agreement.{" "}
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>
                            <strong>
                              When will we cover your legal fees and costs?{" "}
                            </strong>
                          </p>
                        </td>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>Usually, if you win. </p>
                        </td>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>
                            If you win an arbitration you initiate (meaning you
                            recover more than we offered before the
                            arbitration), we will pay your reasonable fees and
                            costs for attorneys, experts and witnesses. We will
                            always pay these amounts if required under
                            applicable law or the administrator's rules or if
                            payment is required to enforce this Arbitration
                            Agreement. The Neutral shall not limit his or her
                            award of these amounts because your Claim is for a
                            small amount. Despite the foregoing, unless required
                            by law or to enforce this Arbitration Agreement, the
                            Neutral is not required to award any fees and costs
                            for your attorneys, experts and witnesses that are
                            incurred by you with respect to a Claim after the
                            time we make a written offer to resolve such Claim
                            for relief in excess of the relief ultimately
                            awarded by the Neutral.{" "}
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>
                            <strong>
                              Will you ever owe us for arbitration or attorneys'
                              fees?{" "}
                            </strong>
                          </p>
                        </td>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>
                            Generally, only for bad faith or breaches of this
                            Arbitration Agreement.{" "}
                          </p>
                        </td>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>
                            The Neutral can require you to pay our fees if: (1)
                            the Neutral finds that you have acted in bad faith
                            (as measured by the standards set forth in Federal
                            Rule of Civil Procedure 11(b)); and (2) this power
                            does not make this Arbitration Agreement invalid.
                            Also, you may be liable for certain arbitration fees
                            in a Group Arbitration, as provided below. Finally,
                            you may be responsible for some or all of our legal
                            fees resulting from a bad faith breach of this
                            Arbitration Agreement, if a court or arbitrator
                            determines that assessing such fees to be warranted
                            under the circumstances and the power to assess such
                            fees does not make this Arbitration Agreement
                            invalid.
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>
                            <strong>
                              Can a failure to resolve a Claim informally result
                              in a larger recovery for you?{" "}
                            </strong>
                          </p>
                        </td>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>Yes, except in Group Arbitrations. </p>
                        </td>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>
                            Except for Claims resolved in or after a Group
                            Arbitration, you are entitled to an arbitration
                            award of at least $7,500 if: (1) you give us notice
                            of a Claim on your own behalf (and not on behalf of
                            any other party) and comply with all of the
                            requirements of this Arbitration Agreement
                            (including the requirements described in response to
                            the question reading "What must a party do before
                            starting a lawsuit or arbitration?"); and (2) the
                            Neutral awards you money damages greater than the
                            last amount you requested at least ten days before
                            the arbitration commenced. This is in addition to
                            any attorneys' fees and expenses (including expert
                            witness fees and costs) to which you are otherwise
                            entitled. This $7,500 minimum award is a single
                            award that applies to all Claims you have raised or
                            could have raised in the arbitration. Multiple
                            awards of $7,500 are not contemplated by this
                            Arbitration Agreement. Settlement demands and offers
                            are strictly confidential. They may not be used in
                            any proceeding by any party except to justify a
                            minimum recovery of $7,500.{" "}
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>
                            <strong>Can an award be explained? </strong>
                          </p>
                        </td>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>Yes. </p>
                        </td>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>
                            A party may request details from the Neutral, within
                            14 days of the ruling. Upon such request, the
                            Neutral will explain the ruling in writing.{" "}
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>
                            <strong>
                              Can you arbitrate or can we require arbitration of
                              Common Issues in a Group Arbitration?
                            </strong>
                          </p>
                        </td>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>Sometimes.</p>
                        </td>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>
                            It is possible that many Claimants will pursue or
                            threaten Claims against us involving Common Issues.
                            Depending upon the circumstances, this may make
                            individual arbitrations impractical or unduly
                            costly. The Group Arbitration provisions of this
                            Arbitration Agreement are designed to address this
                            problem.
                          </p>
                          <p>
                            Any group of 50-250 Claimants who have given Claim
                            Notices that involve Common Issues and are not
                            already participating in individual arbitrations
                            under this Arbitration Agreement may form a "
                            <strong>Qualifying Group</strong>" to participate
                            jointly in a Group Arbitration, provided that no
                            Claimant who is already a member of a Qualifying
                            Group may join a different Qualifying Group. Also,
                            we may form a Qualifying Group of 50-250 such
                            Claimants, provided that no Claimant who is already
                            a member of a Qualifying Group may be included in a
                            different Qualifying Group. The Qualifying Group for
                            a Group Arbitration shall be deemed to be formed
                            upon delivery of notice from such Qualifying Group
                            to us or from us to the members of such Qualifying
                            Group or their counsel (a "
                            <strong>Group Arbitration Notice</strong>"). All
                            rights and duties of a Qualifying Group under this
                            Arbitration Agreement will be exercised or performed
                            by a majority of the members of the Qualifying Group
                            (a "<strong>Group Majority</strong>") or a
                            Qualifying Group representative appointed by a Group
                            Majority (a "<strong>Group Agent</strong>").{" "}
                          </p>
                          <p>
                            In the event a new Claimant asserts a Claim that
                            involves a Common Issue that is being addressed in
                            an existing Group Arbitration, either we, a Group
                            Majority or a Group Agent may require the new
                            Claimant to participate in the existing Group
                            Arbitration, so long as the Claimants in such Group
                            Arbitration will remain a Qualifying Group.
                          </p>
                          <p>
                            Different Qualifying Groups may bring separate Group
                            Arbitrations to resolve the same or different Common
                            Issues (for example, if there are more than 250
                            Claimants with Common Issues) but no Claimant may
                            participate in an arbitration of the same Common
                            Issue in more than one Qualifying Group. A different
                            Neutral must be appointed for each Group
                            Arbitration, and no single Neutral may hear more
                            than one Group Arbitration of the same Common
                            Issues. Claims on a class basis or Claims for public
                            injunctions may not be heard or decided in Group
                            Arbitrations. decided in Group Arbitrations.{" "}
                          </p>
                          <p>
                            Upon formation of a Qualifying Group, all Common
                            Issues affecting such Qualifying Group shall be
                            resolved by Group Arbitration under this Arbitration
                            Agreement. Before commencement of a Group
                            Arbitration for such Qualifying Group, the AAA shall
                            be consulted about the fees and charges (or fee
                            schedule) it will impose for such Group Arbitration,
                            including Neutral charges. For 15 days after
                            receiving final fee and charge information from the
                            AAA, either we or the Qualifying Group may elect for
                            the Group Arbitration to be conducted without
                            assistance of the AAA, in accordance with the
                            provisions set forth under the caption "What happens
                            if a party wishes a Group Arbitration to be
                            conducted without an administrator?"
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>
                            <strong>
                              Who bears arbitration costs in Group Arbitrations?
                            </strong>
                          </p>
                        </td>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>
                            Usually, arbitration costs will be shared 50/50 by
                            us and the Qualified Group.
                          </p>
                        </td>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>
                            In a Group Arbitration, fees and charges of the
                            arbitration administrator (if any) and Neutral will
                            normally be shared 50/50 by us and the Qualified
                            Group. However, we will bear some or all of the
                            Qualifying Group's share of such fees and charges to
                            the extent: (1) required by law; (2) required to
                            enforce this Arbitration Agreement; and/or (3)
                            awarded by the Neutral in the Neutral's discretion.{" "}
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>
                            <strong>
                              What happens if you are a Claimant in a Qualifying
                              Group but have a Claim that cannot be resolved in
                              a Group Arbitration?{" "}
                            </strong>
                          </p>
                        </td>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>
                            The Claim can be resolved in a lawsuit or an
                            arbitration under this Arbitration Agreement.
                          </p>
                        </td>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>
                            After a Group Arbitration, any Claim that cannot be
                            resolved in the Group Arbitration will be subject to
                            this Arbitration Agreement. Before initiating a
                            lawsuit or arbitration with respect to such Claim,
                            the Claimant must give the Respondent a new Claim
                            Notice and right to resolve such Claim, as described
                            under the caption "What must a party do before
                            starting a lawsuit or arbitration?"
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>
                            <strong>
                              What happens if a party wishes a Group Arbitration
                              to be conducted without an administrator?
                            </strong>
                          </p>
                        </td>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>Special rules will apply.</p>
                        </td>
                        <td
                          style={{ border: "1px solid black", padding: "8px" }}
                        >
                          <p>
                            If either we or a Qualifying Group give timely
                            notice of a desire for the Group Arbitration to be
                            conducted without AAA, we and the Qualifying Group
                            shall try to agree upon a Neutral to conduct the
                            Group Arbitration. If we and the Qualifying Group do
                            not reach agreement upon a Neutral within 30 days
                            after the date of the notice referenced above, we or
                            a Group Majority may petition a court with
                            jurisdiction for appointment of a Neutral. The court
                            shall give due regard to the qualifications of the
                            Neutral and the fees charged by the Neutral. Neutral
                            fees exceeding the Neutral fees paid by the AAA in
                            its consumer arbitrations are disfavored. A
                            court-appointed Neutral must be a lawyer with at
                            least ten years of experience or a retired federal
                            or state judge unless we and the Qualifying Group
                            otherwise agree.{" "}
                          </p>
                          <p>
                            Once a Neutral has been selected and retained, such
                            Neutral will commence and conduct the Group
                            Arbitration in accordance with this Arbitration
                            Agreement and, to the extent not inconsistent with
                            this Arbitration Agreement: (a) Rules R-2, R-7
                            through R-9, R-14 and R-18 through R-54 of the AAA's
                            Consumer Arbitration Rules, Amended and Effective
                            September 1, 2014 (even if subsequently revised),{" "}
                            <em>available online </em>at adr.org/consumer or
                            available from us (the "
                            <strong>Governing Rules</strong>"); and (b) such
                            additional procedures as the Neutral shall adopt.
                            However:
                          </p>
                          <div style={{ paddingLeft: "24px" }}>
                            <p>
                              (i) The AAA shall have no role in the arbitration
                              and no filings with or notices to the AAA shall be
                              required. Such filings will be made with the
                              Neutral or not at all, as the circumstances shall
                              dictate.{" "}
                            </p>
                            <p>
                              (ii) Subject to subsection (i), any reference to
                              the AAA in the Governing Rules shall be deemed to
                              refer instead to the Neutral or, if a function
                              delegated to the AAA under the Governing Rules
                              cannot reasonably be performed by the Neutral,
                              whether by virtue of a conflict of interest or
                              otherwise, by a court with jurisdiction. Any
                              objection to the Neutral under R-19 shall be
                              decided by a court with jurisdiction.
                            </p>
                            <p>
                              (iii) No administrative fees under R-4 shall be
                              payable.
                            </p>
                            <p>
                              (iv) Despite R-29, an in-person or telephonic
                              hearing shall be held upon agreement of the
                              parties or for good cause shown.
                            </p>
                            <p>
                              (v) Despite R-33, the Neutral may allow the filing
                              of a dispositive motion without prejudging the
                              likelihood of success.
                            </p>
                            <p>
                              (vi) Despite R-40 and R-42, the Neutral may extend
                              the applicable time limits in unusual and extreme
                              circumstances.
                            </p>
                            <p>(vii) R-43(c) shall not apply.</p>
                          </div>
                          <p>
                            The Costs of Arbitration and fee sections of the
                            Governing Rules shall not apply, provided that the
                            Arbitrator Compensation terms shall be used as
                            guidelines.
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </li>
                <li>
                  <strong>FOR COMMERCIAL CARDS ONLY: </strong>Dispute
                  Resolution.
                  <ol>
                    <li>
                      Any claim, dispute, or controversy (“Claim”) arising out
                      of or relating in any way to: (i) this Agreement; (ii) the
                      Account or Cards; (iii) your acquisition of the Account or
                      Cards; (iv) your use of the Account or Cards; (v) the
                      amount of available funds in the Account; (vi)
                      advertisements, promotions or oral or written statements
                      related to the Account or Cards, as well as goods or
                      services purchased with the Account or Cards; (vii) the
                      benefits and services related to the Account or Cards; or
                      (viii) transactions made using the Account or Cards, no
                      matter how described, pleaded or styled, shall be FINALLY
                      and EXCLUSIVELY resolved by binding individual arbitration
                      conducted by the American Arbitration Association (“AAA”)
                      under its commercial Arbitration Rules. This arbitration
                      agreement is made pursuant to a transaction involving
                      interstate commerce, and shall be governed by the Federal
                      Arbitration Act (9 U.S.C. 1-16). The arbitration shall
                      occur in Fulton County, Georgia.
                    </li>
                    <li>
                      ARBITRATION OF YOUR CLAIM IS MANDATORY AND BINDING.
                      NEITHER PARTY WILL HAVE THE RIGHT TO LITIGATE THAT CLAIM
                      THROUGH A COURT. IN ARBITRATION, NEITHER PARTY WILL HAVE
                      THE RIGHT TO A JURY TRIAL OR TO ENGAGE IN DISCOVERY,
                      EXCEPT AS PROVIDED FOR IN THE AAA CODE OF PROCEDURE.
                    </li>
                    <li>
                      For a copy of the procedures, to file a Claim or for other
                      information about this organization, contact it at: AAA,
                      335 Madison Avenue, New York, NY 10017, or at{" "}
                      <a href="http://www.adr.org">www.adr.org</a>.
                    </li>
                    <li>
                      All determinations as to the scope, interpretation,
                      enforceability and validity of this Agreement shall be
                      made final exclusively by the arbitrator, which award
                      shall be binding and final. Judgment on the arbitration
                      award may be entered in any court having jurisdiction.
                    </li>
                    <li>
                      NO CLASS ACTION, OR OTHER REPRESENTATIVE ACTION OR PRIVATE
                      ATTORNEY GENERAL ACTION OR JOINDER OR CONSOLIDATION OF ANY
                      CLAIM WITH A CLAIM OF ANOTHER PERSON OR CLASS OF CLAIMANTS
                      SHALL BE ALLOWABLE.
                    </li>
                    <li>
                      This arbitration provision shall survive: i) the
                      termination of the Agreement; ii) the bankruptcy of any
                      party; iii) any transfer, sale or assignment of your
                      Account, or any amounts owed on your Account, to any other
                      person or entity; or iv) closing of the Account. If any
                      portion of this arbitration provision is deemed invalid or
                      unenforceable, the remaining portions shall remain in
                      force.
                    </li>
                    <li>
                      IF YOU DO NOT AGREE TO THE TERMS OF THIS ARBITRATION
                      AGREEMENT, EMAIL US AT support@prioritypassport.com TO
                      CLOSE THE CARD ACCOUNT AND REQUEST A REFUND, IF
                      APPLICABLE. YOU MUST DO SO WITHIN 30 DAYS OF OBTAINING A
                      CARD OR USING THE ACCOUNT OR THIS ARBITRATION AGREEMENT
                      WILL BE BINDING.{" "}
                    </li>
                  </ol>
                </li>
                <li>
                  <strong>Governing Law. </strong>This Agreement shall be
                  governed by and construed in accordance with all applicable
                  federal laws and all applicable substantive laws of the State
                  of Georgia. In addition, we are subject to certain federal and
                  state regulations and local clearing house rules governing the
                  subject matter of the Agreement. You understand that we must
                  comply with these laws, regulations and rules. You agree that
                  if there is any inconsistency between the terms of this
                  Agreement and any applicable law, regulation or rule, the
                  terms of this Agreement will prevail to the extent any such
                  law, regulation or rule may be modified by agreement.
                </li>
                <li>
                  <strong>Termination. </strong>We and you may each terminate
                  this relationship unilaterally at any time upon notice. To
                  close your Passport Account and terminate this Agreement,
                  please contact us as provided in Section 6.10. Cancellation of
                  this Agreement will not affect any of your or our rights or
                  obligations arising under this Agreement prior to
                  cancellation.
                  <ol>
                    <li>
                      You understand and acknowledge that even after executing
                      this Agreement and opening a Passport Account, Bank has
                      the right to close your Account and terminate this
                      relationship, and you will have no right to compel Bank to
                      grant access to Bank services, either initially or after a
                      Passport Account is opened.
                    </li>
                    <li>
                      If we cancel, close or terminate the Passport Account, we
                      will be responsible for sending you prior notice in
                      accordance with applicable law. Specific information and
                      instructions, including how to convert and receive any
                      remaining Passport Account balance will be included in the
                      notice. You agree that advance written notice from us will
                      be reasonable if it is emailed to you at your email
                      address we have on file for you or mailed to your
                      statement mailing address at least thirty (30) calendar
                      days prior to the date upon which an Account will be
                      closed and this Agreement terminated. You agree that in
                      instances of Account abuse, or to prevent a loss, notice
                      is reasonably given by us if mailed immediately upon
                      Account closure. For security reasons, we may require you
                      to close your Account and to open a new Account if: there
                      is a change in power of attorney; there has been a forgery
                      or fraud reported or committed involving your Account; or
                      any other provision of our Agreement with you is violated.
                      After the Account is closed, we have no obligation to
                      accept deposits or pay any scheduled ACH transfers.
                    </li>
                    <li>
                      IMPORTANT: We reserve the right to close your Account if
                      you terminate all your other relationships with us. Upon
                      closure, any remaining funds in the Passport Account will
                      be converted and returned to you in accordance with this
                      Section.
                    </li>
                    <li>
                      If your Passport Account is canceled, closed or terminated
                      for any reason, you may request the balance to be returned
                      to an external account that you have maintained, including
                      any linked External Account. Allow at least fourteen (14)
                      days for the processing of such balance return to the
                      extent permitted by law. If you do not request the balance
                      to be returned to an external account within 20 business
                      days after the Account is closed, unless you are notified
                      otherwise, Priority will instruct Bank to return any
                      remaining funds in the Passport Account in a check mailed
                      to the address on file associated with the Passport
                      Account. Our obligations to you with regard to the Account
                      balance will be fully satisfied after complying with this
                      section.
                    </li>
                  </ol>
                </li>
              </ol>
            </li>
          </ol>

          <ol>
            <li id="footnote-2">
              <p>
                Bank refers to, but is not limited to, any of the following
                financial institutions: Wells Fargo, N.A., Comerica Bank, Axos
                Bank, and Western Alliance Bank. We may add or remove financial
                institutions from the definition of “Bank” in our discretion
                without notice.
              </p>
            </li>
          </ol>
        </div>
      </div>
    </>
  );
};

export default PassportAgreementSila;
